/*! tsc-media-extensions-js - v7.1.0 - 2019-03-14 */(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define('vendor.tscme', ["_","q","tinycolor"], function (a0,b1,c2) {
      return factory(a0,b1,c2);
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require("_"),require("Q"),require("tinycolor"));
  } else {
    root['tscme'] = factory(root["_"],root["Q"],root["tinycolor"]);
  }
}(this, function (_, Q, tinycolor) {

var tscme = {};

(function (tscme, _) {
   'use strict';

   var decoratorFunctions = [];
   var nullCaptionText = {
      text: undefined,
      plainText: undefined,
      markupText: undefined
   };

   var Caption = function (params) {
      var _startTime;
      var _duration;
      var _captionTextList = [];
      var _horizontalAlignment;
      var _verticalAlignment;
      var _file;
      var _image;
      var _imageIndex;
      var _imageOffset;
      var _imageRectangle;
      var _activeLanguageIdentifier = tscme.LanguageIdentifier.create(tscme.languageIdentifiers.identifiers.default);
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var getAvailableLanguages = function() {
         return _.map(_captionTextList, function(captionText) {
            return captionText.languageIdentifier.identifier;
         });
      };

      var setStartTime = function (startTime) {
         if (typeof startTime !== 'number') {
            throw(new Error('Caption startTime is expecting a number, but got (' + startTime + ')'));
         }
         var previous = _startTime;
         _startTime = Math.floor(startTime);
         return tscme.UndoAction.create(setStartTime, previous, setStartTime, _startTime);
      };

      var setDuration = function (duration) {
         if (typeof duration !== 'number') {
            throw(new Error('Caption duration is expecting a number, but got (' + duration + ')'));
         }
         var previous = _duration;
         _duration = Math.floor(duration);
         return tscme.UndoAction.create(setDuration, previous, setDuration, _duration);
      };

      var addOrReplaceCaptionText = function(newCaptionItem) {
         var existingCaptionItemIndex = _.findIndex(_captionTextList, function(captionItem) { return captionItem.languageIdentifier.identifier === newCaptionItem.languageIdentifier.identifier; });
         if (existingCaptionItemIndex !== -1) {
            var oldCaptionItem = _captionTextList[existingCaptionItemIndex];
            _captionTextList.splice(existingCaptionItemIndex, 1, newCaptionItem);
            return tscme.UndoAction.create(addOrReplaceCaptionText, oldCaptionItem, addOrReplaceCaptionText, newCaptionItem);
         } else {
            _captionTextList.push(newCaptionItem);
            return tscme.UndoAction.create(removeCaptionText, newCaptionItem, addOrReplaceCaptionText, newCaptionItem);
         }
      };

      var removeCaptionText = function(captionText) {
         var removedCaptionItems = _.remove(_captionTextList, function(captionTextItem) {
            return (captionTextItem.languageIdentifier.identifier === captionText.languageIdentifier.identifier && captionTextItem.text === captionText.text);
         });

         var removedCaptionItem = removedCaptionItems.length > 0 ? removedCaptionItems[0] : undefined;
         return tscme.UndoAction.create(addOrReplaceCaptionText, removedCaptionItem, removeCaptionText, captionText);
      };

      var setHorizontalAlignment = function (horizontalAlignment) {
         if (typeof horizontalAlignment !== 'string') {
            throw(new Error('Caption horizontalAlignment is expecting a string, but got (' + horizontalAlignment + ')'));
         }
         var previous = _horizontalAlignment;
         _horizontalAlignment = horizontalAlignment;
         return tscme.UndoAction.create(setHorizontalAlignment, previous, setHorizontalAlignment, _horizontalAlignment);
      };

      var setVerticalAlignment = function (verticalAlignment) {
         if (typeof verticalAlignment !== 'string') {
            throw(new Error('Caption verticalAlignment is expecting a string, but got (' + verticalAlignment + ')'));
         }
         var previous = _verticalAlignment;
         _verticalAlignment = verticalAlignment;
         return tscme.UndoAction.create(setVerticalAlignment, previous, setVerticalAlignment, _verticalAlignment);
      };

      var setFile = function (file) {
         if (typeof file !== 'string') {
            throw(new Error('Caption file is expecting a string, but got (' + file + ')'));
         }
         var previous = _file;
         _file = file;
         return tscme.UndoAction.create(setFile, previous, setFile, _file);
      };

      var setImage = function (image) {
         if (typeof image !== 'string') {
            throw(new Error('Caption image is expecting a string, but got (' + image + ')'));
         }
         var previous = _image;
         _image = image;
         return tscme.UndoAction.create(setImage, previous, setImage, _image);
      };

      var setImageIndex = function (imageIndex) {
         if (typeof imageIndex !== 'number') {
            throw(new Error('Caption imageIndex is expecting a number, but got (' + imageIndex + ')'));
         }
         var previous = _imageIndex;
         _imageIndex = imageIndex;
         return tscme.UndoAction.create(setImageIndex, previous, setImageIndex, _imageIndex);
      };

      var setImageOffset = function (imageOffset) {
         if (typeof imageOffset !== 'number') {
            throw(new Error('Caption imageOffset is expecting a number, but got (' + imageOffset + ')'));
         }
         var previous = _imageOffset;
         _imageOffset = imageOffset;
         return tscme.UndoAction.create(setImageOffset, previous, setImageOffset, _imageOffset);
      };

      var setImageRectangle = function (imageRectangle) {
         if (typeof imageRectangle !== 'object') {
            throw(new Error('Caption imageRectangle is expecting an object, but got (' + imageRectangle + ')'));
         }
         var previous = _imageRectangle;
         _imageRectangle = imageRectangle;
         return tscme.UndoAction.create(setImageRectangle, previous, setImageRectangle, _imageRectangle);
      };

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:startTime': _startTime,
                     'xmpDM:duration': _duration,
                     'tscDM:halign': _horizontalAlignment,
                     'tscDM:valign': _verticalAlignment,
                     'tscDM:file': _file,
                     'tscDM:image': _image,
                     'tscDM:imageindex': _imageIndex,
                     'tscDM:imageoffset': _imageOffset,
                     'tscDM:imagerect': _imageRectangle ? [_imageRectangle.x, _imageRectangle.y, _imageRectangle.width, _imageRectangle.height].join(', ') : undefined
                  },
                  'children': [
                     {
                        name: 'xmpDM:name',
                        children: [
                           {
                              name: 'rdf:Alt',
                              children: _captionTextList
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var getCaptionText = function() {
         if (_captionTextList.length === 0) {
            return nullCaptionText;
         }

         if (_activeLanguageIdentifier.identifier === tscme.languageIdentifiers.identifiers.default) {
            return _captionTextList[0];
         } else {
            var preferredCaptionText = _.find(_captionTextList, function(captionText) {
               return captionText.languageIdentifier.identifier === _activeLanguageIdentifier.identifier;
            });

            if (!preferredCaptionText) {
               preferredCaptionText = _.find(_captionTextList, function(captionText) {
                  return captionText.language === _activeLanguageIdentifier.language;
               });
            }

            return preferredCaptionText || nullCaptionText;
         }
      };

      var _public = Object.defineProperties({},
         {
            startTime: {
               get: function () {
                  return _startTime;
               }
            },
            duration: {
               get: function () {
                  return _duration;
               }
            },
            endTime: {
               get: function () {
                  return _startTime + _duration;
               }
            },
            captionTextList: {
               get: function () {
                  return _captionTextList;
               }
            },
            text: {
               get: function () {
                  return getCaptionText().text;
               }
            },
            plainText: {
               get: function () {
                  return getCaptionText().plainText;
               }
            },
            markupText: {
               get: function () {
                  return getCaptionText().markupText;
               }
            },
            horizontalAlignment: {
               get: function () {
                  return _horizontalAlignment;
               }
            },
            verticalAlignment: {
               get: function () {
                  return _verticalAlignment;
               }
            },
            file: {
               get: function () {
                  return _file;
               }
            },
            image: {
               get: function () {
                  return _image;
               }
            },
            imageIndex: {
               get: function () {
                  return _imageIndex;
               }
            },
            imageOffset: {
               get: function () {
                  return _imageOffset;
               }
            },
            imageRectangle: {
               get: function () {
                  return _imageRectangle;
               }
            },
            activeLanguageIdentifier: {
               get: function() {
                  return _activeLanguageIdentifier;
               },
               set: function(languageIdentifier) {
                  _activeLanguageIdentifier = languageIdentifier;
               }
            }

         });

      _public.getAvailableLanguages = getAvailableLanguages;
      _public.setStartTime = setStartTime;
      _public.setDuration = setDuration;
      _public.addOrReplaceCaptionText = addOrReplaceCaptionText;
      _public.removeCaptionText = removeCaptionText;
      _public.setHorizontalAlignment = setHorizontalAlignment;
      _public.setVerticalAlignment = setVerticalAlignment;
      _public.setFile = setFile;
      _public.setImage = setImage;
      _public.setImageIndex = setImageIndex;
      _public.setImageOffset = setImageOffset;
      _public.setImageRectangle = setImageRectangle;

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            startTime: _startTime,
            duration: _duration,
            captionTextList: _.invokeMap(_captionTextList, 'toPOJO'),
            horizontalAlignment: _horizontalAlignment,
            verticalAlignment: _verticalAlignment,
            file: _file,
            image: _image,
            imageIndex: _imageIndex,
            imageOffset: _imageOffset,
            imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : _imageRectangle
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'startTime') {
               setStartTime(params.startTime);
            } else if (key === 'duration') {
               setDuration(params.duration);
            } else if (key === 'captionTextList') {
               _.map(params.captionTextList, addOrReplaceCaptionText);
            } else if (key === 'horizontalAlignment') {
               setHorizontalAlignment(params.horizontalAlignment);
            } else if (key === 'verticalAlignment') {
               setVerticalAlignment(params.verticalAlignment);
            } else if (key === 'file') {
               setFile(params.file);
            } else if (key === 'image') {
               setImage(params.image);
            } else if (key === 'imageIndex') {
               setImageIndex(params.imageIndex);
            } else if (key === 'imageOffset') {
               setImageOffset(params.imageOffset);
            } else if (key === 'imageRectangle') {
               if (!params.imageRectangle.toPOJO) {
                  params.imageRectangle = tscme.ImageRectangle.create(params.imageRectangle);
               }
               setImageRectangle(params.imageRectangle);
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      _.forEach(decoratorFunctions, function (func) {
         func(_public);
      });

      return _public;
   };

   var createFromXmpElement = function (captionElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var captionTextElements = _xmlUtility.getElementsByTagNameNSPrefix(captionElement, 'rdf:li');
      var captionTextList = _.map(captionTextElements, tscme.CaptionText.createFromXmpElement);

      var params = {
         startTime: Number(captionElement.getAttribute('xmpDM:startTime')),
         duration: Number(captionElement.getAttribute('xmpDM:duration')),
         captionTextList: captionTextList,
         horizontalAlignment: captionElement.getAttribute('tscDM:halign'),
         verticalAlignment: captionElement.getAttribute('tscDM:valign')
      };

      if (captionElement.getAttribute('tscDM:file')) {
         params.file = captionElement.getAttribute('tscDM:file');
      }

      if (captionElement.getAttribute('tscDM:image')) {
         params.image = captionElement.getAttribute('tscDM:image');
      }

      if (captionElement.getAttribute('tscDM:imageindex')) {
         params.imageIndex = Number(captionElement.getAttribute('tscDM:imageindex'));
      }

      if (captionElement.getAttribute('tscDM:imageoffset')) {
         params.imageOffset = Number(captionElement.getAttribute('tscDM:imageoffset'));
      }

      if (captionElement.getAttribute('tscDM:imagerect')) {
         params.imageRectangle = tscme.ImageRectangle.create(captionElement.getAttribute('tscDM:imagerect'));
      }

      return Caption(params);
   };

   var registerDecorator = function (decorator) {
      if (decorator && typeof decorator === 'function') {
         decoratorFunctions.push(decorator);
      } else {
         throw 'decorator must be a function';
      }
   };

   var clearDecorators = function () {
      decoratorFunctions = [];
   };

   tscme.Caption = {
      /**
       *  Factory method that returns a new Caption object.
       *  @function create
       *  @param {Object} params - Optional params for caption
       *  @param {Number} [params.startTime] - Start time of caption.
       *  @param {Number} [params.duration] - Duration of caption.
       *  @param {tscme.CaptionText[]} [params.captionTextList] - List of CaptionText objects.
       *  @param {String} [params.horizontalAlignment] - Horizontal alignment of caption text.
       *  @param {String} [params.verticalAlignment] - Vertical alignment of caption text.
       *  @param {String} [params.file] - Reference to a specific file as String.
       *  @param {String} [params.image] - Url for caption thumbnail.
       *  @param {Number} [params.imageIndex] - Index of image within file consisting of one or more images.
       *  @param {Number} [params.imageOffset] - Number of bytes this image begins at, relative to the beginning of the entire file
       *  @param {tscme.ImageRectangle} [params.imageRectangle] - Image Rectangle for image sprite map
       *  @static
       *  @return {tscme.Caption} new Caption instance
       */
      create: function (params) {
         return Caption(params);
      },

      /**
       *  Factory method that returns a new Caption object from an XMP caption element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP caption element.
       *  @static
       *  @return {tscme.Caption} new Caption instance
       */
      createFromXmpElement: createFromXmpElement,

      /**
       *  Method to allow registration of decorator function that can extend the caption
       *  object before it is returned in the create functions.
       *  @function registerDecorator
       *  @param {Function} decorator - Function that will be used to decorate the caption.
       *  The function should take a caption parameter.
       *  @static
       */
      registerDecorator: registerDecorator,
      /**
       *  Method to allow clearing decorator functions
       *  @function clearDecorators
       *  @static
       */
      clearDecorators: clearDecorators
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var CaptionCollection = function (params) {
      var _captions = [];
      var _activeLanguageIdentifier = tscme.LanguageIdentifier.create(tscme.languageIdentifiers.identifiers.default);
      var _captionLanguages = {};

      var addCaptionFromLanguageCodeCache = function(caption) {
         caption.getAvailableLanguages().forEach(function(language) {
            if (!_captionLanguages[language]) {
               _captionLanguages[language] = 1;
            } else {
               _captionLanguages[language]++;
            }
         });
      };

      var removeCaptionFromLanguageCodeCache = function(caption) {
         caption.getAvailableLanguages().forEach(function(language) {
            if (_captionLanguages[language]) {
               _captionLanguages[language]--;
            }

            if (_captionLanguages[language] === 0) {
               delete _captionLanguages[language];
            }
         });
      };

      var addCaption = function (caption) {
         addCaptionFromLanguageCodeCache(caption);
         caption.activeLanguageIdentifier = _activeLanguageIdentifier;
         var index = _.sortedIndexBy(_captions, caption, 'startTime');
         _captions.splice(index, 0, caption);
         return tscme.UndoAction.create(removeCaption, caption, addCaption, caption);
      };

      var removeCaption = function (caption) {
         removeCaptionFromLanguageCodeCache(caption);
         var index = _.findIndex(_captions, caption);
         if (index !== -1) {
            _captions.splice(index, 1);
            return tscme.UndoAction.create(addCaption, caption, removeCaption, caption);
         }
         return tscme.UndoAction.noOp();
      };

      var setCaptions = function(captions) {
         _captions = captions;
         _captionLanguages = [];
         _captions.forEach(function(caption) {
            addCaptionFromLanguageCodeCache(caption);
         });
      };

      var clear = function() {
         var captionsClone = _.clone(_captions);
         _captions = [];
         _captionLanguages = [];
         return tscme.UndoAction.create(setCaptions, captionsClone, setCaptions, []);
      };

      var getAvailableLanguages = function() {
         return Object.keys(_captionLanguages);
      };

      var setActiveLanguageIdentifier = function(languageIdentifierString) {
         if (!tscme.languageIdentifiers.isSupportedLanguage(languageIdentifierString)) {
            languageIdentifierString = tscme.languageIdentifiers.identifiers.default;
         }
         var languageIdentifier = tscme.LanguageIdentifier.create(languageIdentifierString);
         var previousActiveLanguageIdentifierString = _activeLanguageIdentifier.identifier;
         _activeLanguageIdentifier = languageIdentifier;
         _.forEach(_captions, function(caption) {
            caption.activeLanguageIdentifier = languageIdentifier;
         });
         return tscme.UndoAction.create(setActiveLanguageIdentifier, previousActiveLanguageIdentifierString, setActiveLanguageIdentifier, languageIdentifierString);
      };

      var getActiveLanguageIdentifier = function() {
         return _activeLanguageIdentifier;
      };

      if (params) {
         if (params.hasOwnProperty('captions') && _.isArray(params.captions)) {
            _captions = _.sortBy(params.captions, ['startTime']);
            _captions.forEach(function(caption) {
               addCaptionFromLanguageCodeCache(caption);
            });
         } else {
            throw(new Error('CaptionCollection params is expecting an object eg. { captions: [caption1Object, ...] }'));
         }
      }

      var _public = Object.defineProperties({},
         {
            captions: {
               get: function () {
                  return _captions;
               }
            }
         });

      _public.setActiveLanguageIdentifier = setActiveLanguageIdentifier;
      _public.getActiveLanguageIdentifier = getActiveLanguageIdentifier;
      _public.getAvailableLanguages = getAvailableLanguages;
      _public.addCaption = addCaption;
      _public.removeCaption = removeCaption;
      _public.clear = clear;

      _public.toPOJO = function () {
         return {
            captions: _captions
         };
      };

      return _public;
   };

   tscme.CaptionCollection = {
      /**
       *  Factory method that returns a new CaptionCollection object.
       *  @function create
       *  @param {Object} params - Optional params for caption
       *  @param {Array} [params.captions] - array containing {tscme.Caption} objects.
       *  @static
       *  @return {tscme.CaptionCollection} new CaptionCollection instance
       */
      create: function (params) {
         return CaptionCollection(params);
      }
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var validateParams = function (params) {
      return params && typeof params.text === 'string' && typeof params.languageIdentifierString === 'string';
   };

   var CaptionText = function (params) {
      var _languageIdentifier = tscme.LanguageIdentifier.create(tscme.languageIdentifiers.identifiers.default);
      var _text;
      var _plainText;
      var _markupText;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var setLanguageIdentifier = function (languageIdentifierString) {
         if (!tscme.languageIdentifiers.isSupportedLanguage(languageIdentifierString)) {
            languageIdentifierString = tscme.languageIdentifiers.identifiers.default;
         }

         var previousLanguageIdentifierString = _languageIdentifier.identifier;
         _languageIdentifier = tscme.LanguageIdentifier.create(languageIdentifierString);
         return tscme.UndoAction.create(setLanguageIdentifier, previousLanguageIdentifierString, setLanguageIdentifier, languageIdentifierString);
      };

      var setText = function (text) {
         if (typeof text !== 'string') {
            throw(new Error('Caption text is expecting a string, but got (' + text + ')'));
         }
         var previous = _text;
         _text = text;
         _plainText = tscme.Rtf.toText(_text);
         _markupText = tscme.Rtf.toHtml(_text);
         return tscme.UndoAction.create(setText, previous, setText, _text);
      };

      var toXmp = function () {
         var treeDesc = {
                  name: 'rdf:li',
                  'atts': {
                     'xml:lang': _languageIdentifier.identifier
                  },
                  text: _text
               };
         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            languageIdentifier: {
               get: function() {
                  return _languageIdentifier;
               }
            },
            language: {
               get: function () {
                  return _languageIdentifier.language;
               }
            },
            text: {
               get: function () {
                  return _text;
               }
            },
            plainText: {
               get: function () {
                  return _plainText;
               }
            },
            markupText: {
               get: function () {
                  return _markupText;
               }
            }
         });

      _public.setLanguageIdentifier = setLanguageIdentifier;
      _public.setText = setText;
      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            languageIdentifier: _languageIdentifier.toPOJO(),
            language: _languageIdentifier.language,
            text: _text,
            plainText: _plainText,
            markupText: _markupText
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });

         return pojo;
      };

      if (validateParams(params)) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'languageIdentifierString') {
               setLanguageIdentifier(params.languageIdentifierString);
            } else if (key === 'text') {
               setText(params.text);
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      } else {
         throw(new Error('CaptionText expects text and language parameters'));
      }

      return _public;
   };

   var createFromXmpElement = function (textElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);
      var rtfText = _xmlUtility.getElementText(textElement);
      var params = {
         languageIdentifierString: textElement.getAttribute('xml:lang'),
         text: rtfText
      };

      return CaptionText(params);
   };

   tscme.CaptionText = {
      /**
       *  Factory method that returns a new CaptionText object.
       *  @function create
       *  @param {Object} params - Optional params for caption
       *  @param {String} [params.languageIdentifierString] - RFC 3066 notation language string
       *  @param {String} [params.text] - Text of caption item.
       *  @static
       *  @return {tscme.CaptionText} new CaptionText instance
       */
      create: function (params) {
         return CaptionText(params);
      },

      /**
       *  Factory method that returns a new CaptionText object from an XMP caption element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP caption item element.
       *  @static
       *  @return {tscme.CaptionText} new CaptionText instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _, tinycolor) {
   'use strict';

   var CaptionTrack = function (params) {

      params = params || {};

      var _defaults = Object.freeze({
         fontFamily : "Arial, Helvetica, sans-serif;",
         fontSize : 24,
         fgColor: tinycolor({ r: 255, g: 255, b: 255 }),
         bgColor: tinycolor({ r: 0, g: 0, b: 0, a: 0.9 })
      });

      var _fgColor = params.fgColor ? tinycolor(params.fgColor) : _defaults.fgColor.clone();
      var _bgColor = params.bgColor ? tinycolor(params.bgColor) : _defaults.bgColor.clone();
      var _fontFamily = params.fontFamily ? params.fontFamily : _defaults.fontFamily;
      var _fontSize = parseFontSize(params, _defaults.fontSize);
      var _position = params.position ? params.position : undefined;
      var _barHeight = params.barHeight ? params.barHeight : undefined;
      var _captionCollection = params.captions ? tscme.CaptionCollection.create({captions: params.captions}) : tscme.CaptionCollection.create();
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:trackType': 'Caption',
                     'xmpDM:frameRate': 'f1000',
                     'xmpDM:trackName': 'Captioning',
                     'stFnt:fontFamily': _fontFamily,
                     'tscDM:fontSize': _fontSize,
                     'tscDM:bgOpacity': _bgColor.getAlpha(),
                     'tscDM:position': _position,
                     'tscDM:captionbarheight': _barHeight
                  },
                  'children': [
                     {
                        name: 'xmpDM:markers',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _captionCollection.captions
                           }
                        ]
                     },
                     {
                        name: 'tsc:fgColor',
                        atts: attsFromColor(_fgColor.toRgb())
                     },
                     {
                        name: 'tsc:bgColor',
                        atts: attsFromColor(_bgColor.toRgb())
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var attsFromColor = function(color) {
         return {
            'xmpG:red': color.r,
            'xmpG:green': color.g,
            'xmpG:blue': color.b,
            'xmpG:mode': 'RGB'
         };
      };

      var tinycolorToSimpleRgb = function(tinycolorObj) {
         var rgbaColorObj = tinycolorObj.toRgb();
         return {
            r: rgbaColorObj.r,
            g: rgbaColorObj.g,
            b: rgbaColorObj.b
         };
      };

      var _public = Object.defineProperties({},
         {
            fgColor: {
               get: function () {
                  return tinycolorToSimpleRgb(_fgColor);
               }
            },
            fgHexColor: {
              get: function() {
                  return _fgColor.toHexString();
              }
            },
            bgColor: {
               get: function () {
                  return tinycolorToSimpleRgb(_bgColor);
               }
            },
            bgOpacity: {
               get: function () {
                  return _bgColor.getAlpha();
               }
            },
            bgHexColor: {
               get: function() {
                  return _bgColor.toHexString();
               }
            },
            bgRGBACssColor: {
               get: function() {
                  return _bgColor.toRgbString();
               }
            },
            fontFamily: {
               get: function () {
                  return _fontFamily;
               }
            },
            fontSize: {
               get: function () {
                  return _fontSize;
               }
            },
            position: {
               get: function () {
                  return _position;
               }
            },
            barHeight: {
               get: function () {
                  return _barHeight;
               }
            },
            captionCollection: {
               get: function () {
                  return _captionCollection;
               }
            }
         });

      _public.setActiveLanguageIdentifier = _captionCollection.setActiveLanguageIdentifier;
      _public.getActiveLanguageIdentifier = _captionCollection.getActiveLanguageIdentifier;
      _public.getAvailableLanguages = _captionCollection.getAvailableLanguages;
      _public.toXmp = toXmp;
      _public.toPOJO = function() {
         var pojo = {
            fgColor: _fgColor.toRgb(),
            bgColor: _bgColor.toRgb(),
            bgOpacity: _bgColor.getAlpha(),
            fontFamily: _fontFamily,
            fontSize: _fontSize,
            position: _position,
            barHeight: _barHeight,
            captions: _.invokeMap(_captionCollection.captions, 'toPOJO')
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         return pojo;
      };

      return _public;
   };

   var getRGBColor = function (element) {
      return {
         r: Number(element.getAttribute('xmpG:red')),
         g: Number(element.getAttribute('xmpG:green')),
         b: Number(element.getAttribute('xmpG:blue'))
      };
   };

   var parseFontSize = function(params, defaultFontSize) {
      if (!params.fontSize){
         return defaultFontSize;
      }

      var parsedFontSize = +params.fontSize;
      if (_.isString(params.fontSize)) {
         parsedFontSize = +params.fontSize.replace('px', '').replace('pt', '');
      }
      return parsedFontSize ? parsedFontSize : defaultFontSize;
   };

   var createFromXmpElement = function (captionTrackElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);
      var captionTrack = new CaptionTrack();

      if (captionTrackElement) {
         var fgColorElement = _xmlUtility.getFirstElementByTagNameNSPrefix(captionTrackElement, 'tsc:fgColor');
         var bgColorElement = _xmlUtility.getFirstElementByTagNameNSPrefix(captionTrackElement, 'tsc:bgColor');

         var captionElements = _xmlUtility.getElementsByTagNameNSPrefix(captionTrackElement, 'rdf:Description');
         var captions = _.map(captionElements, tscme.Caption.createFromXmpElement);

         var params = {
            fgColor: getRGBColor(fgColorElement),
            bgColor: getRGBColor(bgColorElement),
            fontFamily: captionTrackElement.getAttribute('stFnt:fontFamily'),
            fontSize: Number(captionTrackElement.getAttribute('tscDM:fontSize')),
            position: captionTrackElement.getAttribute('tscDM:position'),
            barHeight: Number(captionTrackElement.getAttribute('tscDM:captionbarheight')),
            captions: captions
         };
         params.bgColor.a = !_.isNil(captionTrackElement.getAttribute('tscDM:bgOpacity')) ?
            Number(captionTrackElement.getAttribute('tscDM:bgOpacity')) : _defaults.bgColor.getAlpha();

         captionTrack = new CaptionTrack(params);
      }

      return captionTrack;
   };

   tscme.CaptionTrack = {
      /**
       *  Factory method that returns a new CaptionTrack object.
       *  @function create
       *  @param {Object} params - Optional params for caption track
       *  @param {Object} [params.fgColor] - RGB values for foreground color.
       *  @param {Number} [params.bgOpacity] - Opacity of background.
       *  @param {String} [params.fontFamily] - Font family for caption track.
       *  @param {String} [params.fontSize] - Font size for caption track.
       *  @param {String} [params.position] - Position for caption track.
       *  @param {String} [params.barHeight] - Bar height for caption track.
       *  @static
       *  @return {tscme.CaptionTrack} new CaptionTrack instance
       */
      create: function (params) {
         return CaptionTrack(params);
      },

      /**
       *  Factory method that returns a new CaptionTrack object from an XMP caption track element.
       *  @function create
       *  @param {Object} element - XMP caption track element.
       *  @static
       *  @return {tscme.CaptionTrack} new CaptionTrack instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _, tinycolor);


(function (tscme) {
   'use strict';

   var LanguageIdentifier = function (languageIdentifier) {
      if (typeof languageIdentifier !== 'string') {
         throw(new Error('Language Identifier is expecting a string, but got (' + languageIdentifier + ')'));
      }

      var _identifier = languageIdentifier.toLowerCase();
      var _language = '';
      var _region = '';

      var parseLanguageIdentifier = function () {
         var languageIdentifierParts = _identifier.split('-');
         if (languageIdentifierParts.length > 1) {
            _region = languageIdentifierParts.pop();
         }
         _language = languageIdentifierParts.join('-');
      };

      var toPOJO = function() {
         return {
            identifier: _identifier,
            language: _language,
            region: _region
         };
      };

      parseLanguageIdentifier();

      return Object.defineProperties(
         {
            toPOJO: toPOJO
         },
         {
            identifier: {
               get: function() {
                  return _identifier;
               }
            },
            language: {
               get: function () {
                  return _language;
               }
            },
            region: {
               get: function () {
                  return _region;
               }
            }
         });
   };

   tscme.LanguageIdentifier = {
      /**
       *  Factory method that returns a new LanguageIdentifier object.
       *  @function create
       *  @param {string} languageIdentifier - RFC 3066 notation language string
       *  @static
       *  @return {tscme.LanguageIdentifier} new LanguageIdentifier instance
       */
      create: LanguageIdentifier
   };
})(tscme);

(function (tscme) {
   'use strict';

   var _identifiers = Object.freeze({
      'default': 'default',
      'af': {
         name: 'Afrikaans',
         displayName: 'Afrikaans',
         regions: {
            'za': 'South Africa'
         }
      },
      'sq': {
         name: 'Albanian',
         displayName: 'Shqip',
         regions: {
            'al': 'Albania'
         }
      },
      'ar': {
         name: 'Arabic',
         displayName: 'العربية',
         regions: {
            'dz': 'Algeria',
            'bh': 'Bahrain',
            'eg': 'Egypt',
            'iq': 'Iraq',
            'jo': 'Jordan',
            'kw': 'Kuwait',
            'lb': 'Lebanon',
            'ly': 'Libya',
            'ma': 'Morocco',
            'om': 'Oman',
            'qa': 'Qatar',
            'sa': 'Saudi Arabia',
            'sy': 'Syria',
            'tn': 'Tunisia',
            'ae': 'United Arab Emirates',
            'ye': 'Yemen'
         }
      },
      'hy': {
         name: 'Armenian',
         displayName: 'Արևելահայերեն',
         regions: {
            'am': 'Armenia'
         }
      },
      'cy-az': {
         name: 'Azeri (Cyrillic)',
         displayName: 'Азәрбајҹан дили',
         regions: {
            'az': 'Azerbaijan'
         }
      },
      'lt-az': {
         name: 'Azeri (Latin)',
         displayName: 'Azərbaycanca',
         regions: {
            'az': 'Azerbaijan'
         }
      },
      'eu': {
         name: 'Basque',
         displayName: 'Euskara',
         regions: {
            'es': 'Basque'
         }
      },
      'be': {
         name: 'Belarusian',
         displayName: 'Беларуская',
         regions: {
            'by': 'Belarus'
         }
      },
      'bg': {
         name: 'Bulgarian',
         displayName: 'Български',
         regions: {
            'bg': 'Bulgaria'
         }
      },
      'ca': {
         name: 'Catalan',
         displayName: 'Català',
         regions: {
            'es': 'Catalan'
         }
      },
      'zh': {
         name: 'Chinese',
         displayName: '简体中文',
         regions: {
            'cn': 'China',
            'hk': 'Hong Kong SAR',
            'mo': 'Macau SAR',
            'sg': 'Singapore',
            'tw': 'Taiwan',
            'chs': '(Simplified)',
            'cht': '(Traditional)'
         }
      },
      'hr': {
         name: 'Croatian',
         displayName: 'hrvatski',
         regions: {
            'hr': 'Croatia'
         }
      },
      'cs': {
         name: 'Czech',
         displayName: 'Čeština',
         regions: {
            'cz': 'Czech Republic'
         }
      },
      'da': {
         name: 'Danish',
         displayName: 'Dansk',
         regions: {
            'dk': 'Denmark'
         }
      },
      'div': {
         name: 'Dhivehi',
         displayName: 'ދިވެހި',
         regions: {
            'mv': 'Maldives'
         }
      },
      'nl': {
         name: 'Dutch',
         displayName: 'Nederlands',
         regions: {
            'be': 'Belgium',
            'nl': 'The Netherlands'
         }
      },
      'en': {
         name: 'English',
         displayName: 'English',
         regions: {
            'au': 'Australia',
            'bz': 'Belize',
            'ca': 'Canada',
            'cb': 'Caribbean',
            'ie': 'Ireland',
            'jm': 'Jamaica',
            'nz': 'New Zealand',
            'ph': 'Philippines',
            'za': 'South Africa',
            'tt': 'Trinidad and Tobago',
            'gb': 'United Kingdom',
            'us': 'United States',
            'zw': 'Zimbabwe'
         }
      },
      'et': {
         name: 'Estonian',
         displayName: 'Eesti',
         regions: {
            'ee': 'Estonia'
         }
      },
      'fo': {
         name: 'Faroese',
         displayName: 'Føroyskt',
         regions: {
            'fo': 'Faroe Islands'
         }
      },
      'fa': {
         name: 'Farsi',
         displayName: 'فارسی',
         regions: {
            'ir': 'Iran'
         }
      },
      'fi': {
         name: 'Finnish',
         displayName: 'Suomi',
         regions: {
            'fi': 'Finland'
         }
      },
      'fr': {
         name: 'French',
         displayName: 'Français',
         regions: {
            'be': 'Belgium',
            'ca': 'Canada',
            'fr': 'France',
            'lu': 'Luxembourg',
            'mc': 'Monaco',
            'ch': 'Switzerland'
         }
      },
      'gl': {
         name: 'Galician',
         displayName: 'galego',
         regions: {
            'es': 'Galician'
         }
      },
      'ka': {
         name: 'Georgian',
         displayName: 'ქართული',
         regions: {
            'ge': 'Georgia'
         }
      },
      'de': {
         name: 'German',
         displayName: 'Deutsch',
         regions: {
            'at': 'Austria',
            'de': 'Germany',
            'li': 'Liechtenstein',
            'lu': 'Luxembourg',
            'ch': 'Switzerland'
         }
      },
      'el': {
         name: 'Greek',
         displayName: 'Ελληνικά',
         regions: {
            'gr': 'Greece'
         }
      },
      'gu': {
         name: 'Gujarati',
         displayName: 'ગુજરાતી',
         regions: {
            'in': 'India'
         }
      },
      'he': {
         name: 'Hebrew',
         displayName: 'עברית',
         regions: {
            'il': 'Israel'
         }
      },
      'hi': {
         name: 'Hindi',
         displayName: 'हिन्दी',
         regions: {
            'in': 'India'
         }
      },
      'hu': {
         name: 'Hungarian',
         displayName: 'Magyar',
         regions: {
            'hu': 'Hungary'
         }
      },
      'is': {
         name: 'Icelandic',
         displayName: 'Íslenska',
         regions: {
            'is': 'Iceland'
         }
      },
      'id': {
         name: 'Indonesian',
         displayName: 'Bahasa Indonesia',
         regions: {
            'id': 'Indonesia'
         }
      },
      'it': {
         name: 'Italian',
         displayName: 'Italiano',
         regions: {
            'it': 'Italy',
            'ch': 'Switzerland'
         }
      },
      'ja': {
         name: 'Japanese',
         displayName: '日本語',
         regions: {
            'jp': 'Japan'
         }
      },
      'kn': {
         name: 'Kannada',
         displayName: 'ಕನ್ನಡ',
         regions: {
            'in': 'India'
         }
      },
      'kk': {
         name: 'Kazakh',
         displayName: 'Қазақ Tілі',
         regions: {
            'kz': 'Kazakhstan'
         }
      },
      'kok': {
         name: 'Konkani',
         displayName: 'कोंकणी',
         regions: {
            'in': 'India'
         }
      },
      'ko': {
         name: 'Korean',
         displayName: '한국어',
         regions: {
            'kr': 'Korea'
         }
      },
      'ky': {
         name: 'Kyrgyz',
         displayName: 'кыргызча',
         regions: {
            'kz': 'Kazakhstan'
         }
      },
      'lv': {
         name: 'Latvian',
         displayName: 'Latviešu',
         regions: {
            'lv': 'Latvia'
         }
      },
      'lt': {
         name: 'Lithuanian',
         displayName: 'Lietuvių',
         regions: {
            'lt': 'Lithuania'
         }
      },
      'mk': {
         name: 'Macedonian',
         displayName: 'Mакедонски',
         regions: {
            'mk': '(FYROM)'
         }
      },
      'ms': {
         name: 'Malay',
         displayName: 'Bahasa Melayu',
         regions: {
            'bn': 'Brunei',
            'my': 'Malaysia'
         }
      },
      'mr': {
         name: 'Marathi',
         displayName: 'मराठी',
         regions: {
            'in': 'India'
         }
      },
      'mn': {
         name: 'Mongolian',
         displayName: 'Монгол Хэл',
         regions: {
            'mn': 'Mongolia'
         }
      },
      'nb': {
         name: 'Norwegian (Bokmål)',
         displayName: 'Norsk (Bokmål)',
         regions: {
            'no': 'Norway'
         }
      },
      'nn': {
         name: 'Norwegian (Nynorsk)',
         displayName: 'Norsk (Nynorsk)',
         regions: {
            'no': 'Norway'
         }
      },
      'pl': {
         name: 'Polish',
         displayName: 'Polsk',
         regions: {
            'pl': 'Poland'
         }
      },
      'pt': {
         name: 'Portuguese',
         displayName: 'Português',
         regions: {
            'br': 'Brazil',
            'pt': 'Portugal'
         }
      },
      'pa': {
         name: 'Punjabi',
         displayName: 'ਪੰਜਾਬੀ',
         regions: {
            'in': 'India'
         }
      },
      'ro': {
         name: 'Romanian',
         displayName: 'Română',
         regions: {
            'ro': 'Romania'
         }
      },
      'ru': {
         name: 'Russian',
         displayName: 'Русский',
         regions: {
            'ru': 'Russia'
         }
      },
      'sa': {
         name: 'Sanskrit',
         displayName: 'संस्कृतम्',
         regions: {
            'in': 'India'
         }
      },
      'cy-sr': {
         name: 'Serbian (Cyrillic)',
         displayName: 'Српски',
         regions: {
            'sp': 'Serbia'
         }
      },
      'lt-sr': {
         name: 'Serbian (Latin)',
         displayName: 'Srpski',
         regions: {
            'sp': 'Serbia'
         }
      },
      'sk': {
         name: 'Slovak',
         displayName: 'Slovenčina',
         regions: {
            'sk': 'Slovakia'
         }
      },
      'sl': {
         name: 'Slovenian',
         displayName: 'Slovenščina',
         regions: {
            'si': 'Slovenia'
         }
      },
      'es': {
         name: 'Spanish',
         displayName: 'Español',
         regions: {
            'ar': 'Argentina',
            'bo': 'Bolivia',
            'cl': 'Chile',
            'co': 'Colombia',
            'cr': 'Costa Rica',
            'do': 'Dominican Republic',
            'ec': 'Ecuador',
            'sv': 'El Salvador',
            'gt': 'Guatemala',
            'hn': 'Honduras',
            'mx': 'Mexico',
            'ni': 'Nicaragua',
            'pa': 'Panama',
            'py': 'Paraguay',
            'pe': 'Peru',
            'pr': 'Puerto Rico',
            'es': 'Spain',
            'uy': 'Uruguay',
            've': 'Venezuela'
         }
      },
      'sw': {
         name: 'Swahili',
         displayName: 'Kiswahili',
         regions: {
            'ke': 'Kenya'
         }
      },
      'sv': {
         name: 'Swedish',
         displayName: 'Svenska',
         regions: {
            'fi': 'Finland',
            'se': 'Sweden'
         }
      },
      'syr': {
         name: 'Syriac',
         displayName: 'ܠܫܢܐ ܣܘܪܝܝܐ‎',
         regions: {
            'sy': 'Syria'
         }
      },
      'ta': {
         name: 'Tamil',
         displayName: 'தமிழ்‎',
         regions: {
            'in': 'India'
         }
      },
      'tt': {
         name: 'Tatar',
         displayName: 'татар теле',
         regions: {
            'ru': 'Russia'
         }
      },
      'te': {
         name: 'Telugu',
         displayName: 'తెలుగు',
         regions: {
            'in': 'India'
         }
      },
      'th': {
         name: 'Thai',
         displayName: 'ไทย',
         regions: {
            'th': 'Thailand'
         }
      },
      'tr': {
         name: 'Turkish',
         displayName: 'Türkçe',
         regions: {
            'tr': 'Turkey'
         }
      },
      'uk': {
         name: 'Ukrainian',
         displayName: 'Українська',
         regions: {
            'ua': 'Ukraine'
         }
      },
      'ur': {
         name: 'Urdu',
         displayName: 'اُردُو',
         regions: {
            'pk': 'Pakistan'
         }
      },
      'cy-uz': {
         name: 'Uzbek (Cyrillic)',
         displayName: 'Ўзбек',
         regions: {
            'uz': 'Uzbekistan'
         }
      },
      'lt-uz': {
         name: 'Uzbek (Latin)',
         displayName: 'oʻzbek tili',
         regions: {
            'uz': 'Uzbekistan'
         }
      },
      'vi': {
         name: 'Vietnamese',
         displayName: 'Tiếng Việt',
         regions: {
            'vn': 'Vietnam'
         }
      }
   });

   /**
    *  Check if a language is supported.
    *  @function isSupportedLanguage
    *  @param {string} languageIdentifierString - RFC 3066 notation language string
    *  @static
    *  @return {boolean} is the language found in the languageIdentifier is found.
    */
   var isSupportedLanguage = function(languageIdentifierString) {
      var identifier = tscme.LanguageIdentifier.create(languageIdentifierString);
      return _identifiers[identifier.language] !== undefined;
   };

   tscme.languageIdentifiers = Object.defineProperties({
      isSupportedLanguage: isSupportedLanguage
   }, {
      identifiers: {
         get: function() {
            return _identifiers;
         }
      }
   });
})(tscme);

(function (tscme) {
   'use strict';

   var TAG_BEGIN_NOTATION = '\\';
   var TAG_CLOSE_NOTATION = '0';
   var TAG_END_NOTATION = ' ';
   var TAG_SPACE = ' ';
   var LOWER_CASE_A_CHAR_CODE = 97;
   var LOWER_CASE_Z_CHAR_CODE = 122;

   var isBlacklistedTag = function (strTag) {
      var LINE_BREAK = 'par ';
      return strTag.toLowerCase() === LINE_BREAK;
   };

   var findNextTag = function (strTextToSearch, nStartPoint) {
      if (nStartPoint === undefined) {
         nStartPoint = 0;
      }

      var nPosition = -1;
      // Make sure we're not null
      if (strTextToSearch) {
         // Get the first tag-looking sequence
         nPosition = strTextToSearch.indexOf(TAG_BEGIN_NOTATION, nStartPoint);
         // While we've got a tag-looking sequence....
         while (nPosition != -1) {
            // As long as this point is not the last character in the string
            if (nPosition + 1 < strTextToSearch.length) {
               var nCode = strTextToSearch.toLowerCase().charCodeAt(nPosition + 1);
               // If the lower-case character is a lower-case alpha character
               if (LOWER_CASE_A_CHAR_CODE <= nCode && nCode <= LOWER_CASE_Z_CHAR_CODE) {
                  break;
               }
            }
            // Get the next location of a tag-looking sequence
            nPosition = strTextToSearch.indexOf(TAG_BEGIN_NOTATION, nPosition + 1);
         }
      }

      // Return -1 of the position of the first valid tag
      return nPosition;
   };

   var getTagAt = function (strText, nTagPosition) {
      var strTag;
      if (nTagPosition !== -1) {
         var nEnd = strText.indexOf(TAG_END_NOTATION, nTagPosition + 1);
         if (nEnd !== -1) {
            var nLength = (nEnd + 1) - (nTagPosition + 1);
            strTag = strText.substr(nTagPosition + 1, nLength);
         }
         else {
            strTag = strText.substr(nTagPosition + 1);
         }
      }
      return strTag;
   };

   var findNextTagNotBlacklisted = function (strTextToSearch, nStartPoint) {
      if (nStartPoint === undefined) {
         nStartPoint = 0;
      }

      var nPosition = findNextTag(strTextToSearch, nStartPoint);
      while (nPosition !== -1) {
         var strTag = getTagAt(strTextToSearch, nPosition);

         if (strTag && !isBlacklistedTag(strTag)) {
            break;
         }

         nPosition = findNextTag(strTextToSearch, nPosition + 1);
      }

      return nPosition;
   };

   var getTextToCloseTag = function (strTag, arrStack) {
      var strCloseTags = '';
      var arrOpenTags = [];
      var strCloseTagNeeded = arrStack.pop();

      while (strCloseTagNeeded && strCloseTagNeeded !== strTag && arrStack.length) {
         strCloseTags += (TAG_BEGIN_NOTATION + strCloseTagNeeded);

         arrOpenTags.push(matchingTag(strCloseTagNeeded));

         if (arrStack.length) {
            strCloseTagNeeded = arrStack.pop();
         }
      }

      strCloseTags += (TAG_BEGIN_NOTATION + strTag);

      while (arrOpenTags.length) {
         var strOpenTagNeeded = arrOpenTags.pop();
         if (strOpenTagNeeded) {
            strCloseTags += (TAG_BEGIN_NOTATION + strOpenTagNeeded);
            arrStack.push(matchingTag(strOpenTagNeeded));
         }
      }

      return strCloseTags;
   };

   var isClosingTag = function (strTag) {
      return strTag.indexOf(TAG_CLOSE_NOTATION) !== -1;
   };

   var matchingTag = function (strToMatch) {
      var strMatch = '';

      if (strToMatch !== '') {
         // An end tag
         if (isClosingTag(strToMatch)) {
            strMatch = strToMatch.substr(0, strToMatch.indexOf(TAG_CLOSE_NOTATION));
         }
         // Not an end tag
         else {
            // If we need to remove space (and we should)
            if (strToMatch.indexOf(TAG_SPACE) !== -1) {
               strMatch = strToMatch.substr(0, strToMatch.indexOf(TAG_SPACE));
            }
            strMatch += TAG_CLOSE_NOTATION;
         }
         strMatch += TAG_SPACE;
      }

      return strMatch;
   };

   var removeTag = function (strToFix, nTagPosition) {
      if (nTagPosition !== -1 && strToFix && nTagPosition < strToFix.length) {
         // Get the end of the tag
         var nTagEnd = strToFix.indexOf(TAG_END_NOTATION, nTagPosition);
         // If end exists
         if (nTagEnd !== -1) {
            // Remove it
            strToFix = strToFix.substr(0, nTagPosition) + strToFix.substr(nTagEnd + 1);
         } else {
            strToFix = strToFix.substr(0, nTagPosition);
         }
      }
      return strToFix;
   };

   var trimString = function (strToFix) {
      while (strToFix.length > 1 && strToFix.charAt(0) === TAG_SPACE) {
         strToFix = strToFix.substr(1);
      }

      while (strToFix.length > 1 && strToFix.charAt(strToFix.length - 1) === TAG_SPACE) {
         strToFix = strToFix.substr(0, strToFix.length - 1);
      }

      if (strToFix === TAG_SPACE) {
         strToFix = '';
      }

      return strToFix;
   };

   var nestTags = function (strToFix) {
      if (strToFix) {
         var arrTagStack = [];
         var nPosition = findNextTagNotBlacklisted(strToFix);
         while (nPosition !== -1) {
            // Please note: the "tag" is considered to be what follows the backslash that signals it's beginning.
            var strTag = getTagAt(strToFix, nPosition);
            if (strTag && isClosingTag(strTag)) {
               // Get the new tag set required to add it in to the string
               var strCloseTags = getTextToCloseTag(strTag, arrTagStack);

               // Insert the tags and don't forget the rest of the original, if there is any
               var nTagEnd = strToFix.indexOf(TAG_END_NOTATION, nPosition);
               if (nTagEnd !== -1) {
                  strToFix = strToFix.substr(0, nPosition) + strCloseTags + strToFix.substr(nTagEnd + 1);
               } else {
                  strToFix = strToFix.substr(0, nPosition) + strCloseTags;
               }

               // Increment this so that we're not going through the stuff we just inserted
               nPosition += strCloseTags.length;
            }
            else {
               if (strTag && !isBlacklistedTag(strTag)) {
                  arrTagStack.push(matchingTag(strTag));
               }

               nPosition = Number(nPosition) + 1;
            }
            nPosition = findNextTag(strToFix, nPosition);
         }
      }

      return strToFix;
   };

   var removeEmptyTags = function (strToFix) {
      var strFixed = strToFix;

      if (strFixed) {
         // Loop through the entire string as long as there were corrections made last time
         // (in case more can be made based on the previous ones)
         var nCountCorrectedThisLoop = 1;
         while (nCountCorrectedThisLoop > 0) {
            nCountCorrectedThisLoop = 0;
            // Get the first tag that isn't blacklisted
            var nPosition = findNextTagNotBlacklisted(strFixed);
            while (nPosition !== -1) {
               // Get the next tag that's not blacklisted
               var nNextPosition = findNextTagNotBlacklisted(strFixed, nPosition + 1);

               // Get the actual tag
               var strTag = getTagAt(strFixed, nPosition);
               // If the actual tag exists
               if (strTag) {
                  // As long as that next tag is actually found
                  if (nNextPosition != -1) {
                     // Set up the alternate tag that we're trying to match with
                     var strAlternateTag = matchingTag(strTag);

                     // Get the actual next tag
                     var strNextTag = getTagAt(strFixed, nNextPosition);
                     // If the actual next tag exists and is the same as what we're looking for
                     if (strNextTag && strNextTag == strAlternateTag) {
                        // Get the string between the two tags
                        var nStringBetweenBegin = nPosition + 1 + strTag.length;
                        var strBetween = strFixed.substr(nStringBetweenBegin, nNextPosition - nStringBetweenBegin);
                        // If the trimmed string is empty
                        if (!trimString(strBetween).length) {
                           // Remove the ending tag
                           strFixed = removeTag(strFixed, nNextPosition);
                           // Then remove the beginning tag that we're actually at
                           strFixed = removeTag(strFixed, nPosition);

                           // Adjust the position of that next tag by the amount of space we've reduced
                           nNextPosition -= (strTag.length + 1);
                           // Note that we've made a correction
                           nCountCorrectedThisLoop++;
                        }
                     }
                  }
               }

               // Set the actual next position for the inner loop
               nPosition = nNextPosition;
            }
         }

      }

      return strFixed;
   };

   var toText = function (str) {
      if (str.match(/{\\rtf1 /)) {
         str = str.replace(/{\\rtf1 /,'');

         if (str.charAt(str.length - 1) == '}') {
            str = str.substr(0, str.length - 1);
         }
      }

      str = str.replace(/\\i /g, '');
      str = str.replace(/\\i0 /g, '');
      str = str.replace(/\\b /g, '');
      str = str.replace(/\\b0 /g, '');
      str = str.replace(/\\ul /g, '');
      str = str.replace(/\\ul0 /g, '');
      str = str.replace(/\\par /g, '');

      str = str.replace(/\\{/g, '{');
      str = str.replace(/\\}/g, '}');
      str = str.replace(/\\\\/g, '\\');

      return str;
   };

   var toHtml = function(str) {
      str = nestTags(str);
      str = removeEmptyTags(str);

      str = str.split('<').join('&lt;');
      str = str.split('>').join('&gt;');

      var removeLastBracket = false;

      //  remove the RTF and Replace with HTML
      if (str.indexOf('{\\rtf1') != -1) {
         str = str.split('{\\rtf1 ').join('');
         removeLastBracket = true;
      }

      str = str.split('\\i0 ').join('</i>');
      str = str.split('\\b0 ').join('</b>');
      str = str.split('\\ul0 ').join('</u>');

      str = str.split('\\i ').join('<i>');
      str = str.split('\\b ').join('<b>');
      str = str.split('\\ul ').join('<u>');
      str = str.split('\\par ').join('<br/>');

      str = str.split('\\{').join('{');
      str = str.split('\\}').join('}');
      str = str.split('\\\\').join('\\');

      if (removeLastBracket && (str.charAt(str.length - 1) === '}')) {
         str = str.substr(0, str.length - 1);
      }

      // convert these so they are displayed and not used as HTML Tags ( exception <br> )
      str = str.split('&lt;br&gt;').join('<br/>');
      str = str.split('&lt;BR&gt;').join('<br/>');

      return str;
   };

   tscme.Rtf = {
      toText: toText,
      toHtml: toHtml
   };
})(tscme);

(function (tscme, Q) {
   'use strict';

   var UndoAction = function (undoFunc, undoParams, redoFunc, redoParams) {
      var execute = function () {
         var defer = Q.defer();

         try {
            undoFunc(undoParams);
         } catch (error) {
            defer.reject(error);
         }

         var redo = tscme.UndoAction.create(redoFunc, redoParams, undoFunc, undoParams);
         defer.resolve(redo);

         return defer.promise;
      };

      return {
         execute: execute
      };
   };

   var NoOpAction = function () {
      return {
         execute: function () {
            return Q();
         }
      };
   };

   tscme.UndoAction = {
      /**
       *  Factory method that returns a new UndoAction object.
       *  @function create
       *  @param {Function} undoFunc - The function that will be used to undo the action.
       *  @param {Object} undoParams - Parameters that will be passed to undo function.
       *  @param {Function} redoFunc - The function that will be use to redo the action.
       *  @param {Object} redoParams - Parameters that will be passed to redo function.
       *  @static
       *  @return {tscme.UndoAction} new Command instance
       */
      create: function (undoFunc, undoParams, redoFunc, redoParams) {
         return new UndoAction(undoFunc, undoParams, redoFunc, redoParams);
      },
      noOp: function () {
         return new NoOpAction();
      }
   };
})(tscme, Q);

(function (tscme, _) {
   'use strict';

   var parseXml;

   // Taken from http://stackoverflow.com/a/17604251
   if (typeof window.DOMParser != 'undefined') {
      var DOMParser_proto = DOMParser.prototype,
         real_parseFromString = DOMParser_proto.parseFromString;

      // Firefox/Opera/IE throw errors on unsupported types
      var canParseHtmlNatively;
      try {
         // WebKit returns null on unsupported types
         if ((new DOMParser()).parseFromString("", "text/html")) {
            // text/html parsing is natively supported
            canParseHtmlNatively = true;
         }
      } catch (ex) {
      }

      if ( !canParseHtmlNatively ) {
         DOMParser_proto.parseFromString = function (markup, type) {
            if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
               var doc = document.implementation.createHTMLDocument(""),
                  doc_elt = doc.documentElement,
                  first_elt;

               doc_elt.innerHTML = markup;
               first_elt = doc_elt.firstElementChild;

               if (doc_elt.childElementCount === 1 &&
                  first_elt.localName.toLowerCase() === "html") {
                  doc.replaceChild(first_elt, doc_elt);
               }

               return doc;
            } else {
               return real_parseFromString.apply(this, arguments);
            }
         };
      }

      parseXml = function (xmlStr, contentType) {
         contentType = contentType || 'text/xml';
         return ( new window.DOMParser() ).parseFromString(xmlStr, contentType);
      };
   } else if (typeof window.ActiveXObject != 'undefined' &&
      new window.ActiveXObject('Microsoft.XMLDOM')) {
      parseXml = function (xmlStr) {
         var xmlDoc = new window.ActiveXObject('Microsoft.XMLDOM');
         xmlDoc.async = 'false';
         xmlDoc.loadXML(xmlStr);
         return xmlDoc;
      };
   } else {
      throw new Error('No XML parser found');
   }

   var xmlDocFragmentToString = function (xmlDoc) {
      var xmlSerializer = new XMLSerializer();
      return xmlSerializer.serializeToString(xmlDoc);
   };

   var xmlDocToString = function (xmlDoc) {
      return '<?xml version="1.0" encoding="UTF-8"?>\n' + this.xmlDocFragmentToString(xmlDoc);
   };

   var getElementText = function (element) {
      return element.textContent;
   };

   var hasAttribute = function (element, attributeName) {
      var attrValue = element.getAttribute(attributeName);
      return !_.isNil(attrValue);
   };

   var hasAttributeWithValue = function (element, attributeName, value) {
      var attrValue = element.getAttribute(attributeName);
      return attrValue === value;
   };

   var createDocument = function () {
      var xmlDocument = document.implementation.createDocument('', '', null);
      return xmlDocument;
   };

   var createElement = function (doc, name) {
      var element = doc.createElement(name);
      return element;
   };

   var createElementWithValue = function (doc, name, value) {
      var element = doc.createElement(name);
      element.appendChild(doc.createTextNode(value));
      return element;
   };

   var getElementsByTagName = function (element, name) {
      var ns = '*';
      var childElements = element.getElementsByTagNameNS(ns, name);
      return childElements;
   };

   var getFirstElementByTagName = function (element, name) {
      var childElements = getElementsByTagName(element, name);
      return childElements && childElements[0] ? childElements[0] : null;
   };

   var getFirstChildElementTextByTagName = function (element, name) {
      var childElement = getFirstElementByTagName(element, name);
      return childElement ? getElementText(childElement) : null;
   };

   var XmlUtility = function() {
   };
   XmlUtility.prototype.parseXml = parseXml;
   XmlUtility.prototype.xmlDocFragmentToString = xmlDocFragmentToString;
   XmlUtility.prototype.xmlDocToString = xmlDocToString;
   XmlUtility.prototype.getElementText = getElementText;
   XmlUtility.prototype.hasAttribute = hasAttribute;
   XmlUtility.prototype.hasAttributeWithValue = hasAttributeWithValue;
   XmlUtility.prototype.createDocument = createDocument;
   XmlUtility.prototype.createElement = createElement;
   XmlUtility.prototype.createElementWithValue = createElementWithValue;
   XmlUtility.prototype.getElementsByTagName = getElementsByTagName;
   XmlUtility.prototype.getFirstElementByTagName = getFirstElementByTagName;
   XmlUtility.prototype.getFirstChildElementTextByTagName = getFirstChildElementTextByTagName;

   tscme.XmlUtility = XmlUtility;
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var isDocument = function (docOrElement) {
      return _.isFunction(docOrElement.evaluate);
   };

   var getFirstElementByTagNameNSPrefix = function (docOrElement, name) {
      if (isDocument(docOrElement)) {
         return docOrElement.evaluate('//' + name, docOrElement, this.namespaceResolver, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
      }
      var childElements = this.getElementsByTagNameNSPrefix(docOrElement, name);
      return childElements && childElements[0] ? childElements[0] : undefined;
   };

   var getElementsByTagNameNSPrefix = function (element, name) {
      if (!element) {
         return null;
      }

      if (name.indexOf(':') === -1) {
         throw 'getElementsByTagNameNSPrefix requires the name passed in to have a namespace prefix. getElementsByTagName can be used if you do not know the prefix.';
      }

      var tokens = name.split(':');
      var ns = this.namespaceResolver(tokens[0]);
      var tagName = name.split(':')[1];
      var childElements = element.getElementsByTagNameNS(ns, tagName);
      return childElements;
   };

   var getFirstChildElementTextByTagNameNSPrefix = function (element, name) {
      var childElement = this.getFirstElementByTagNameNSPrefix(element, name);
      return childElement ? this.getElementText(childElement) : undefined;
   };

   var createDocumentNS = function (ns, prefix, name) {
      var xmlDocument = document.implementation.createDocument(ns, prefix + ':' + name, null);
      return xmlDocument;
   };

   var createElementNS = function (doc, ns, prefix, name) {
      var element = doc.createElementNS(ns, prefix + ':' + name);
      return element;
   };

   var createElementNSWithValue = function (doc, ns, prefix, name, value) {
      var element = createElementNS(doc, ns, prefix, name);
      element.appendChild(doc.createTextNode(value));
      return element;
   };

   var getNSInfo = function(tagName, namespaceResolver) {
      var nameParts = tagName.split(':', 2);
      if (nameParts.length !== 2) {
         throw 'invalid tag name [' + tagName + '] should contain \':\' to define namespace';
      } else if (!namespaceResolver(nameParts[0])) {
         throw 'invalid namespace prefix [' + nameParts[0] + '] was not able to be mapped to known namespace';
      }

      return {
         nsUrl: namespaceResolver(nameParts[0]),
         nsPrefix: nameParts[0],
         tagShortName: nameParts[1]
      };
   };

   var createElementFromObject = function (tagInfo, doc) {
      doc = doc || this.createDocument();
      var that = this;

      if (_.isString(tagInfo)) {
         return createElement(doc, tagInfo);
      } else if (typeof tagInfo === 'object' && typeof tagInfo.toXmp === 'function') {
         return tagInfo.toXmp();
      } else if (typeof tagInfo === 'object' && tagInfo.name) {
         var nsInfo = getNSInfo(tagInfo.name, this.namespaceResolver);
         var newElement = createElementNS(doc, nsInfo.nsUrl, nsInfo.nsPrefix, nsInfo.tagShortName);
         if (tagInfo.atts && typeof tagInfo.atts === 'object') {
            _.forEach(tagInfo.atts, function (attrVal, attrName) {
               if (!_.isNil(attrVal)) {
                  var attNsInfo = getNSInfo(attrName, that.namespaceResolver);
                  if (attNsInfo.nsPrefix !== 'xml') {
                     newElement.setAttributeNS(attNsInfo.nsUrl, attrName, attrVal);
                  } else {
                     newElement.setAttribute(attrName, attrVal);
                  }
               }
            });
         }
         if (tagInfo.children && Array.isArray(tagInfo.children)) {
            _.forEach(tagInfo.children, function (child) {
               if (child) {
                  newElement.appendChild(that.createElementFromObject(child, doc));
               }
            });
         }
         if (tagInfo.text !== undefined && tagInfo.text !== null) {
            newElement.textContent = tagInfo.text;
         }
         return newElement;
      }
      throw 'invalid tag info';
   };

   var NamespaceXmlUtility = function(namespaceResolver){
      if (!namespaceResolver) {
         throw 'namespaceResolver is required';
      }
      this.namespaceResolver = namespaceResolver;
   };

   NamespaceXmlUtility.prototype = Object.create(tscme.XmlUtility.prototype);
   NamespaceXmlUtility.prototype.getFirstElementByTagNameNSPrefix = getFirstElementByTagNameNSPrefix;
   NamespaceXmlUtility.prototype.getElementsByTagNameNSPrefix = getElementsByTagNameNSPrefix;
   NamespaceXmlUtility.prototype.getFirstChildElementTextByTagNameNSPrefix = getFirstChildElementTextByTagNameNSPrefix;
   NamespaceXmlUtility.prototype.createDocumentNS = createDocumentNS;
   NamespaceXmlUtility.prototype.createElementFromObject = createElementFromObject;
   NamespaceXmlUtility.prototype.createElementNS = createElementNS;
   NamespaceXmlUtility.prototype.createElementNSWithValue = createElementNSWithValue;

   tscme.NamespaceXmlUtility = NamespaceXmlUtility;
})(tscme, _);

(function (tscme, _) {
   'use strict';
   // Simple function to convert HH:MM:SS,MMM or HH:MM:SS.MMM to SS.MMM
   // Assume valid, returns 0 on error
   function toSeconds(t_in) {
      var t = t_in.split(':');

      try {
         var s = t[2].split(',');

         // Just in case a . is decimal seperator
         if (s.length === 1) {
            s = t[2].split('.');
         }

         return parseFloat(t[0], 10) * 3600 + parseFloat(t[1], 10) * 60 + parseFloat(s[0], 10) + parseFloat(s[1], 10) / 1000;
      } catch (e) {
         return 0;
      }
   }

   function nextNonEmptyLine(linesArray, position) {
      var idx = position;
      while (!linesArray[idx] && idx < linesArray.length) {
         idx++;
      }
      return idx;
   }

   function lastNonEmptyLine(linesArray) {
      var idx = linesArray.length - 1;

      while (idx >= 0 && !linesArray[idx]) {
         idx--;
      }

      return idx;
   }


   function readCaptionsFromString(input, timeDelimiter, hasIdRow) {
      var captionCollection = tscme.CaptionCollection.create(),
         i = 0,
         index = 0,
         lines,
         time,
         text,
         endIndex,
         caption,
         timeSplitRegex = new RegExp('[\\t ]*' + timeDelimiter + '[\\t ]*'),
         SSATagRegex = /\{(\\[\w]+\(?([\w\d]+,?)+\)?)+\}/gi,
         lessThanRegex = /</g,
         greaterThanRegex = />/g,
         newlinePlaceholderRegex = /\\N/gi;

      // Here is where the magic happens
      // Split on line breaks
      lines = input.split(/(?:\r\n|\r|\n)/gm);
      endIndex = lastNonEmptyLine(lines) + 1;

      for (i = 0; i < endIndex; i++) {
         caption = {};
         text = [];

         i = nextNonEmptyLine(lines, i);
         if (hasIdRow) {
            caption.id = parseInt(lines[i++], 10);
         } else {
            caption.id = i;
         }

         // Split on delimiter (often '-->' or ','), trimming spaces as well
         time = lines[i++].split(timeSplitRegex);

         caption.start = toSeconds(time[0]);

         // So as to trim positioning information from end
         index = time[1].indexOf(" ");
         if (index !== -1) {
            time[1] = time[1].substr(0, index);
         }
         caption.end = toSeconds(time[1]);

         // Build single line of text from multi-line subtitle in file
         while (i < endIndex && lines[i]) {
            text.push(lines[i++]);
         }

         // Join into 1 line, SSA-style linebreaks
         // Strip out other SSA-style tags
         caption.text = text.join("\\N").replace(SSATagRegex, "");

         // Escape HTML entities
          caption.text = caption.text.replace(lessThanRegex, "&lt;").replace(greaterThanRegex, "&gt;");

         // Unescape great than and less than when it makes a valid html tag of a supported style (font, b, u, s, i)
         // Modified version of regex from Phil Haack's blog: http://haacked.com/archive/2004/10/25/usingregularexpressionstomatchhtml.aspx
         // Later modified by kev: http://kevin.deldycke.com/2007/03/ultimate-regular-expression-for-html-tag-parsing-with-php/
         //caption.text = caption.text.replace( /&lt;(\/?(font|b|u|i|s))((\s+(\w|\w[\w\-]*\w)(\s*=\s*(?:\".*?\"|'.*?'|[^'\">\s]+))?)+\s*|\s*)(\/?)&gt;/gi, "<$1$3$7>" );
          caption.text = caption.text.replace(newlinePlaceholderRegex, "\n");

         captionCollection.addCaption(tscme.Caption.create({
               startTime: caption.start * 1000,
               duration: caption.end * 1000 - caption.start * 1000,
               captionTextList: [
                  tscme.CaptionText.create({text: caption.text, languageIdentifierString: 'en-US'})
               ],
               horizontalAlignment: 'Center',
               verticalAlignment: 'Bottom'
            }
         ));
      }

      var captionTrack = tscme.CaptionTrack.create({
         captions: captionCollection.captions
      });
      return captionTrack;
   }

   function padWithZero(inputNumber, width) {
      inputNumber = inputNumber + '';
      return inputNumber.length >= width ? inputNumber : new Array(width - inputNumber.length + 1).join('0') + inputNumber;
   }

   function formatMillisecondsToTimeCode(inputMilliseconds, options) {
      var date = new Date(inputMilliseconds);

      var hoursPaddingIsSet = options.hoursPadding || options.hoursPadding === 0;
      var hoursPadding = hoursPaddingIsSet ? options.hoursPadding : 2;
      var hours = padWithZero(date.getUTCHours(), hoursPadding);
      var minutes = padWithZero(date.getUTCMinutes(), 2);
      var seconds = padWithZero(date.getUTCSeconds(), 2);
      var rawMilliseconds = date.getUTCMilliseconds().toFixed(3).split('.')[0];
      var milliseconds = padWithZero(rawMilliseconds, 3);

      var millisecondDelimiter = options.millisecondDelimiter ? options.millisecondDelimiter : ',';
      return hours+':'+minutes+':'+seconds + millisecondDelimiter + milliseconds;
   }

   function captionsToString(captionTrack, options) {
      function captionToString(output, caption, index) {
         var isBeginningOfString = index === 0;
         if (!isBeginningOfString) {
            output += '\n\n';
         }

         if (options.hasIdRow) {
            var oneBasedIndex = index + 1;
            output += oneBasedIndex;
            output += '\n';
         }

         output += formatMillisecondsToTimeCode(caption.startTime, options) + options.timeDelimiter + formatMillisecondsToTimeCode(caption.endTime, options);

         output += '\n';
         output += caption.text;

         return output;
      }

      return _.reduce(captionTrack.captionCollection.captions, captionToString, options.accumulator);
   }

   tscme.baseNewlineParser = {
      readCaptionsFromStringWithIdRow: function (input, timeDelimiter) {
         return readCaptionsFromString(input, timeDelimiter, true);
      },
      readCaptionsFromString: function (input, timeDelimiter) {
         return readCaptionsFromString(input, timeDelimiter, false);
      },
      captionsToString: captionsToString
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var _parsers = [];

   function trimLeadingDot(extension){
      return _.trimStart(extension, '.');
   }

   var registerParser = function (name, supportedExtensions, parserCreator) {
      _parsers.push({
         name: name,
         extensions: _.map(supportedExtensions, trimLeadingDot),
         create: parserCreator
      });
   };

   var resolveParser = function (extension) {
      var parser = _.find(_parsers, function (parser) {
         return _.includes(parser.extensions, trimLeadingDot(extension));
      });
      return parser ? parser.create() : null;
   };

   tscme.captionParsers = {
      register: registerParser,
      resolveByExtension: resolveParser
   };
})(tscme, _);

(function(tscme, _, tinycolor) {
   'use strict';

   tscme.captionParsers.register('SAMI', ['.sami', '.smi'], function() {
      var _xmlUtility = new tscme.XmlUtility();

      function getElementText(textElement){
         var nonBreakingSpace = String.fromCharCode(0xA0);
         var text = _xmlUtility.getElementText(textElement).replace(nonBreakingSpace, ' ');
         return text;
      }

      function getSyncTagText(tag) {
         var textElements = _xmlUtility.getElementsByTagName(tag, 'p');
         if (textElements.length < 1) {
            return getElementText(tag);
         }

         var elementsText = _.map(textElements, getElementText);

         return _.join(elementsText, '\n');
      }

      function parseSyncTagToCaption(horizontalAlignment, captionCollection, tag) {
         var startTime = +tag.getAttribute('start');

         var captionText = tscme.CaptionText.create({
            languageIdentifierString: 'en-US',
            text: getSyncTagText(tag)
         });

         var createParams = {
            startTime: startTime,
            duration: 0,
            captionTextList: [captionText],
            horizontalAlignment: _.capitalize(horizontalAlignment.toLowerCase()),
            verticalAlignment: 'Bottom'
         };

         captionCollection.addCaption(tscme.Caption.create(createParams));
         return captionCollection;
      }

      function assignCaptionDurationsByFillingCaptionStartTimeGaps(captionCollection) {
         for (var i = 0; i < captionCollection.captions.length; i++) {
            var currentCaption = captionCollection.captions[i];

            var nextCaption = null;
            if (i + 1 < captionCollection.captions.length) {
               nextCaption = captionCollection.captions[i + 1];
            }

            var defaultDuration = 3000;
            var duration = nextCaption ? nextCaption.startTime - currentCaption.endTime : defaultDuration;
            currentCaption.setDuration(duration);
         }

         return captionCollection;
      }

      function removeHtmlComments(input) {
         return input.replace(/<!--|-->/g, '');
      }

      function cssColorToRGB(cssColorValue) {
         if (!cssColorValue) {
            return;
         }
         var result = tinycolor(cssColorValue);
         if (!result.isValid()) {
            return;
         }
         return result.toRgb();
      }

      function parseStyle(text) {
         var fontSizeNoDescriptorRegex = /font-size: *(\d+);/g;
         text = text.replace(fontSizeNoDescriptorRegex, 'font-size: $1px;');

         var doc = document.implementation.createHTMLDocument('');
         var styleElement = doc.createElement('style');
         styleElement.textContent = text;
         doc.body.appendChild(styleElement);
         return styleElement.sheet.cssRules;
      }

      function getCaptionTrackCreateParams(xmlDoc) {
         var styleElements = xmlDoc.getElementsByTagName('style');
         if (styleElements.length < 1) {
            return {};
         }

         var styles = parseStyle(removeHtmlComments(styleElements[0].textContent));

         var captionStyle = _.find(styles, function(s) {
            return s.selectorText.toLowerCase() === 'p';
         });

         captionStyle = captionStyle || _.first(styles);

         return {
            fgColor: cssColorToRGB(captionStyle.style.color),
            bgColor: cssColorToRGB(captionStyle.style.backgroundColor),
            fontFamily: _.trim(captionStyle.style.fontFamily, '"\''),
            fontSize: captionStyle.style.fontSize,
            horizontalAlignment: captionStyle.style.textAlign || 'Center'
         };
      }

      function readCaptionsFromString(input) {
         var captionCollection = tscme.CaptionCollection.create();
         var xmlDoc = _xmlUtility.parseXml(input, 'text/html');
         if (!xmlDoc) {
            console.log('xmlDoc is null');
         }

         var syncElements = xmlDoc.getElementsByTagName('sync');

         var createCaptionTrackParams = getCaptionTrackCreateParams(xmlDoc);

         var parseSyncTagToCaptionWithHorizontalAlignment =_.curry(parseSyncTagToCaption)(createCaptionTrackParams.horizontalAlignment);
         captionCollection = _.reduce(syncElements, parseSyncTagToCaptionWithHorizontalAlignment, captionCollection);
         captionCollection = assignCaptionDurationsByFillingCaptionStartTimeGaps(captionCollection);

         createCaptionTrackParams.captions = captionCollection.captions;

         var captionTrack = tscme.CaptionTrack.create(createCaptionTrackParams);
         return captionTrack;
      }

      function captionToString(output, caption, nextCaption) {
         var text = caption.text;
         if (text) {
            text += '\n';
         }

         output += '<SYNC start="' + caption.startTime + '"><P class="ENCC">' + text + '</P></SYNC>';
         if (nextCaption && nextCaption.startTime > caption.endTime) {
            output += '<SYNC start="' + caption.endTime + '"><P class="ENCC"></P></SYNC>';
         }
         return output;
      }

      function getTextAlignment(captionTrack) {
         var textAlignments = _.reduce(captionTrack.captionCollection.captions, function(alignments, caption) {
            var alignment = caption.horizontalAlignment;
            if(!alignment || _.has(alignments,alignment)) {
               return alignments;
            }
            alignments[alignment] = true;
            return alignments;
         }, {});

         var allAlignments = _.keys(textAlignments);
         return allAlignments.length === 1 ? allAlignments[0].toLowerCase() : 'center';
      }

      function captionsToString(captionTrack) {

         var fontSize = _.isInteger(captionTrack.fontSize) ? captionTrack.fontSize + 'pt' : captionTrack.fontSize;
         var fontFamily = captionTrack.fontFamily;
         var fgHexColor = captionTrack.fgHexColor;
         var bgHexColor = captionTrack.bgHexColor;
         var textAlign = getTextAlignment(captionTrack);

         var samiCaptionHeader =
            '<SAMI>' +
            '<HEAD><TITLE>Captions</TITLE><STYLE TYPE="text/css">' +
            '<!--' +
            'P {	margin-left:  1pt;' +
            'margin-right: 1pt;' +
            'margin-bottom: 2pt;' +
            'margin-top: 2pt;' +
            'text-align: ' + textAlign + ';' +
            'font-size: ' + fontSize + ';' +
            'font-family: ' + fontFamily + ';' +
            'font-weight: normal;' +
            'font-style: normal;' +
            'background-color: ' + bgHexColor + ';' +
            'color: ' + fgHexColor + '; }' +
            '.ENCC {Name: English; lang: en-US; SAMI_Type: CC;}' +
            '-->' +
            '</STYLE></HEAD>' +
            '<BODY>';
         var samiCaptionFooter =
            '</BODY>' +
            '</SAMI>';

         var output = samiCaptionHeader;

         var captionCollection = captionTrack.captionCollection;
         for (var i = 0; i < captionCollection.captions.length; i++) {
            var currentCaption = captionCollection.captions[i];

            var isLastCaption = i === captionCollection.captions.length - 1;
            var nextCaption = isLastCaption ? null : captionCollection.captions[i + 1];

            output = captionToString(output, currentCaption, nextCaption);
         }

         output += samiCaptionFooter;
         return output;
      }

      return {
         deserialize: readCaptionsFromString,
         serialize: captionsToString
      };
   });
})(tscme, _, tinycolor);

(function (tscme) {
   'use strict';

   tscme.captionParsers.register('SBV', ['.sbv'], function () {
      var sbvTimeDelimiter = ',';

      function readCaptionsFromString(input) {
         return tscme.baseNewlineParser.readCaptionsFromString(input, sbvTimeDelimiter);
      }

      function captionsToString(captionCollection) {
         return tscme.baseNewlineParser.captionsToString(captionCollection, { timeDelimiter: sbvTimeDelimiter,
                                                                              accumulator: '',
                                                                              hoursPadding: 1
                                                                            });
      }

      return {
         deserialize: readCaptionsFromString,
         serialize: captionsToString
      };
   });
})(tscme);

(function (tscme) {
   'use strict';

   tscme.captionParsers.register('SRT', ['.srt'], function () {
      var srtEndOfFileMarker = '\n\n\n',
         srtTimeDelimiter = ' --> ';

      function readCaptionsFromString(input) {
         return tscme.baseNewlineParser.readCaptionsFromStringWithIdRow(input, srtTimeDelimiter.trim());
      }

      function captionsToString(captionCollection) {
         var captionString = tscme.baseNewlineParser.captionsToString(captionCollection, { timeDelimiter: srtTimeDelimiter,
                                                                                           accumulator: '\n\n',
                                                                                           hasIdRow: true
                                                                                         });
         return captionString + srtEndOfFileMarker;
      }

      return {
         deserialize: readCaptionsFromString,
         serialize: captionsToString
      };
   });
})(tscme);

(function (tscme, _) {
   'use strict';

   tscme.captionParsers.register('TTML', ['.ttml', '.dfxp'], function () {
      // Code below is taken from https://github.com/mozilla/popcorn-js/blob/master/parsers/parserTTML/popcorn.parserTTML.js

      var rWhitespace = /^[\s]+|[\s]+$/gm,
         rLineBreak = /(?:\r\n|\r|\n)/gm,
         rBreakTag = /(<br *\/?>)/gm;

      // Parse the children of the given node
      function parseChildren(node, timeOffset, region) {
         var currNode = node.firstChild,
            currRegion = getNodeRegion(node, region),
            retVal = [],
            newOffset;

         while (currNode) {
            if (currNode.nodeType === 1) {
               if (currNode.nodeName === "p") {
                  // p is a textual node, process contents as subtitle
                  retVal.push(parseNode(currNode, timeOffset, currRegion));
               } else if (currNode.nodeName === "div") {
                  // div is container for subtitles, recurse
                  newOffset = toSeconds(currNode.getAttribute("begin"));

                  if (newOffset < 0) {
                     newOffset = timeOffset;
                  }

                  retVal.push.apply(retVal, parseChildren(currNode, newOffset, currRegion));
               }
            }

            currNode = currNode.nextSibling;
         }

         return retVal;
      }

      // Get the "region" attribute of a node, to know where to put the subtitles
      function getNodeRegion(node, defaultTo) {
         var region = node.getAttribute("region");

         if (region !== null) {
            return region;
         } else {
            return defaultTo || "";
         }
      }

      // Parse a node for text content
      function parseNode(node, timeOffset, region) {
         var sub = {};

         // Trim left and right whitespace from text and convert non-explicit line breaks
         sub.text = ( node.textContent || node.text ).replace(rWhitespace, "").replace(rLineBreak, "<br />");
         sub.id = node.getAttribute("xml:id") || node.getAttribute("id");
         sub.start = toSeconds(node.getAttribute("begin"), timeOffset);
         sub.end = toSeconds(node.getAttribute("end"), timeOffset);
         sub.target = getNodeRegion(node, region);

         if (sub.end < 0) {
            // No end given, infer duration if possible
            // Otherwise, give end as MAX_VALUE
            sub.end = toSeconds(node.getAttribute("duration"), 0);

            if (sub.end >= 0) {
               sub.end += sub.start;
            } else {
               sub.end = Number.MAX_VALUE;
            }
         }

         return {subtitle: sub};
      }

      function toTimelineSeconds(timeStr, framerate) {
         // Hours and minutes are optional
         // Seconds must be specified
         // Seconds can be followed by milliseconds OR by the frame information
         var validTimeFormat = /^([0-9]+:){0,2}[0-9]+([.;][0-9]+)?$/,
            errorMessage = "Invalid time format",
            digitPairs, lastIndex, lastPair, firstPair,
            frameInfo, frameTime;

         if (typeof timeStr === "number") {
            return timeStr;
         }

         if (typeof timeStr === "string" && !validTimeFormat.test(timeStr)) {
            throw errorMessage;
         }

         digitPairs = timeStr.split(":");
         lastIndex = digitPairs.length - 1;
         lastPair = digitPairs[lastIndex];

         // Fix last element:
         if (lastPair.indexOf(";") > -1) {

            frameInfo = lastPair.split(";");
            frameTime = 0;

            if (framerate && ( typeof framerate === "number" )) {
               frameTime = parseFloat(frameInfo[1], 10) / framerate;
            }

            digitPairs[lastIndex] = parseInt(frameInfo[0], 10) + frameTime;
         }

         firstPair = digitPairs[0];

         return {

            1: parseFloat(firstPair, 10),

            2: ( parseInt(firstPair, 10) * 60 ) +
            parseFloat(digitPairs[1], 10),

            3: ( parseInt(firstPair, 10) * 3600 ) +
            ( parseInt(digitPairs[1], 10) * 60 ) +
            parseFloat(digitPairs[2], 10)

         }[digitPairs.length || 1];
      }

      // Convert time expression to SS.mmm
      // Expression may be absolute to timeline (hh:mm:ss.ms)
      //   or relative ( decimal followed by metric ) ex: 3.4s, 5.7m
      // Returns -1 if invalid
      function toSeconds(t_in, offset) {
         var i;

         if (!t_in) {
            return -1;
         }

         try {
            return toTimelineSeconds(t_in);
         } catch (e) {
            i = getMetricIndex(t_in);
            return parseFloat(t_in.substring(0, i)) * getMultipler(t_in.substring(i)) + ( offset || 0 );
         }
      }

      // In a time string such as 3.4ms, get the index of the first character (m) of the time metric (ms)
      function getMetricIndex(t_in) {
         var i = t_in.length - 1;

         while (i >= 0 && t_in[i] <= "9" && t_in[i] >= "0") {
            i--;
         }

         return i;
      }

      // Determine multiplier for metric relative to seconds
      function getMultipler(metric) {
         return {
               "h": 3600,
               "m": 60,
               "s": 1,
               "ms": 0.001
            }[metric] || -1;
      }

      function readCaptionsFromString(input) {
         var captionCollection = tscme.CaptionCollection.create(),
            node,
            xmlDocument;

         // Null checks
         if (!input) {
            return returnData;
         }

         input = input.replace(/<head>.*<\/head>/, '');
         input = input.replace(rBreakTag, '\\N');


         var _xmlUtility = new tscme.XmlUtility();
         xmlDocument = _xmlUtility.parseXml(input);

         if (!xmlDocument) {
            return captionCollection;
         }

         node = xmlDocument.documentElement.firstChild;

         // Find body tag
         while ( node.nodeName !== "body" ) {
            node = node.nextSibling;
         }

         if (node) {
            var captions = parseChildren(node, 0);

            _.map(captions, function(caption){
               caption = caption.subtitle;
               var createParams = {
                  startTime: caption.start * 1000,
                  duration: caption.end * 1000 - caption.start * 1000,
                  captionTextList: [
                     tscme.CaptionText.create({text: caption.text.replace('\\N', '\n'), languageIdentifierString: 'en-US'}),
                  ],
                  horizontalAlignment: 'Center',
                  verticalAlignment: 'Bottom'
               };

               captionCollection.addCaption(tscme.Caption.create(createParams));
            });
         }

         var captionTrack = tscme.CaptionTrack.create({
            captions: captionCollection.captions
         });
         return captionTrack;
      }

      function captionToString(output, caption, index){
         var oneBasedIndex = index + 1;
          output += '<p xml:id="subtitle' + oneBasedIndex + '" begin="' + caption.startTime / 1000 + 's" end="' + caption.endTime / 1000 + 's">' + caption.text + '</p>';
         return output;
      }

      function captionsToString(captionTrack) {
         var ttmlHeader = '<?xml version="1.0" encoding="UTF-8"?><tt xmlns:tts="http://www.w3.org/2006/04/ttaf1#styling" xmlns="http://www.w3.org/2006/04/ttaf1">' +
            '<head>' +
            '<metadata xmlns:ttm="http://www.w3.org/ns/ttml#metadata"><ttm:title>Captions</ttm:title></metadata>' +
            '<styling xmlns:tts="http://www.w3.org/ns/ttml#styling"><style xml:id="s1" tts:color="white" tts:fontFamily="proportionalSansSerif" tts:fontSize="22px" tts:textAlign="center" /></styling>' +
            '<layout xmlns:tts="http://www.w3.org/ns/ttml#styling"><region xml:id="subtitleArea" style="s1" tts:extent="560px 62px" tts:padding="5px 3px" tts:backgroundColor="black" tts:displayAlign="after" /></layout>' +
            '</head>' +
            '<body region="subtitleArea">' +
            '<div>';

         var ttmlFooter = '</div></body></tt>';

         var output = ttmlHeader;

         for(var i = 0; i < captionTrack.captionCollection.captions.length; i++){
            var currentCaption = captionTrack.captionCollection.captions[i];

            output = captionToString(output, currentCaption, i);
         }

         output += ttmlFooter;
         return output;
      }
      return {
         deserialize: readCaptionsFromString,
         serialize: captionsToString
      };
   });
})(tscme, _);

(function (tscme) {
   'use strict';

   tscme.captionParsers.register('VTT', ['.vtt'], function () {
      var vttTimeDelimiter = '-->';

      // [HH:]MM:SS.mmm string to SS.mmm float
      // Throws exception if invalid
      function toSeconds(t_in) {
         var t = t_in.split(":"),
            l = t_in.length,
            time;

         // Invalid time string provided
         if (l !== 12 && l !== 9) {
            throw "Bad cue";
         }

         l = t.length - 1;

         try {
            time = parseInt(t[l - 1], 10) * 60 + parseFloat(t[l], 10);

            // Hours were given
            if (l === 2) {
               time += parseInt(t[0], 10) * 3600;
            }
         } catch (e) {
            throw "Bad cue";
         }

         return time;
      }

      function parseCueHeader(line) {
         var lineSegments,
            args,
            sub = {},
            rToken = /-->/,
            rWhitespace = /[\t ]+/;

         if (!line || line.indexOf(vttTimeDelimiter) === -1) {
            throw "Bad cue";
         }

         lineSegments = line.replace(rToken, " " + vttTimeDelimiter + " ").split(rWhitespace);

         if (lineSegments.length < 2) {
            throw "Bad cue";
         }

         sub.id = line;
         sub.start = toSeconds(lineSegments[0]);
         sub.end = toSeconds(lineSegments[2]);

         return sub;
      }

      function skipWhitespace(lines, len, i) {
         while (i < len && !lines[i]) {
            i++;
         }

         return i;
      }

      function skipNonWhitespace(lines, len, i) {
         while (i < len && lines[i]) {
            i++;
         }

         return i;
      }

      function skipToCueHeader(lines, len, i) {
         while (i < len && lines[i].indexOf(vttTimeDelimiter) === -1) {
            i++;
         }
         return i;
      }

      function readCaptionsFromString(input) {
         var captionCollection = tscme.CaptionCollection.create(),
            subs = [],
            i = 0,
            len = 0,
            lines,
            text,
            sub,
            newlineRegex = /(?:\r\n|\r|\n)/gm,
            breakTagRegex = /(<br *\/?>)/gm;

         // Here is where the magic happens
         // Split on line breaks
         lines = input.split(newlineRegex);
         len = lines.length;

         // Check for BOF token
         if (len === 0 || lines[0] !== "WEBVTT") {
            return captionCollection;
         }

         i++;

         while (i < len) {
            text = [];

            try {
               i = skipWhitespace(lines, len, i);
               i = skipToCueHeader(lines, len, i);

               sub = parseCueHeader(lines[i++]);

               // Build single line of text from multi-line subtitle in file
               while (i < len && lines[i]) {
                  text.push(lines[i++]);
               }

               // Join lines together to one and build subtitle text
               sub.text = text.join('\n').replace(breakTagRegex, '\n');
               sub.text = ( new window.DOMParser() ).parseFromString(sub.text, 'text/html').documentElement.textContent;

               var createParams = {
                  startTime: sub.start * 1000,
                  duration: sub.end * 1000 - sub.start * 1000,
                  captionTextList: [
                     tscme.CaptionText.create({text: sub.text, languageIdentifierString: 'en-US'})
                  ],
                  horizontalAlignment: 'Center',
                  verticalAlignment: 'Bottom'
               };

               captionCollection.addCaption(tscme.Caption.create(createParams));
            } catch (e) {
               i = skipNonWhitespace(lines, len, i);
            }
         }

         var captionTrack = tscme.CaptionTrack.create({
            captions: captionCollection.captions
         });

         return captionTrack;
      }

      function captionsToString(captionCollection) {
         var captionString = tscme.baseNewlineParser.captionsToString(captionCollection, { timeDelimiter: vttTimeDelimiter,
                                                                                           accumulator: 'WEBVTT\n\n',
                                                                                           hasIdRow: false,
                                                                                           millisecondDelimiter: '.'
                                                                                         });
         return captionString;
      }

      return {
         deserialize: readCaptionsFromString,
         serialize: captionsToString
      };
   });
})(tscme);

(function (tscme, _) {
   'use strict';

   var BoundingPoly = function (coordinatesString) {

      var _coordinates = [];

      var createCoordinate = function (coordinateString) {
         var tokens = coordinateString.split(',');
         return {
            x: Number(tokens[0]),
            y: Number(tokens[1])
         };
      };

      if (coordinatesString && _.isString(coordinatesString)) {
         var coordinateTokens = _.compact(coordinatesString.split(';'));
         _coordinates = _.map(coordinateTokens, createCoordinate);
      } else {
         throw(new Error('BoundingPoly is expecting a coordinate string eg. "0,94;111,90;112,191;0,194;"'));
      }

      var _public = Object.defineProperties({},
         {
            coordinates: {
               get: function () {
                  return _coordinates;
               }
            }
         });

      _public.toPOJO = function () {
         return {
            coordinates: _coordinates
         };
      };

      _public.toXmpAtt = function () {
         return _.map(_coordinates, function (coord) {
            return coord.x +',' + coord.y;
         }).join(';') + ';';
      };

      return _public;
   };

   tscme.BoundingPoly = {
      /**
       *  Factory method that returns a new BoundingPoly object.
       *  @function create
       *  @param {String} coordinatesString - Required coordinate string of the bounding poly eg. "0,94;111,90;112,191;0,194;"
       *  @static
       *  @return {tscme.BoundingPoly} new BoundingPoly instance
       */
      create: function (coordinatesString) {
         return new BoundingPoly(coordinatesString);
      }
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';
   
   var ContentList = function (params) {

      var _items;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'items') {
               _items = params.items;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc =  {
           'name': 'tscDM:contentList',
            'children': [
               {
                  'name': 'rdf:Description',
                  'children': [
                     {
                        'name': 'tscDM:files',
                        'children': [
                           {
                              'name': 'rdf:Seq',
                              children: _.map(_items, function (item) {
                                 return {
                                    'name': 'rdf:li',
                                    'atts': {
                                       'xmpDM:name': item.name,
                                       'xmpDM:value': item.value
                                    }
                                 };
                              })
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            items: {
               get: function () {
                  return _items;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            items: _items
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var parseParameter = function (parameterElement) {
      return {
         name: parameterElement.getAttribute('xmpDM:name'),
         value: parameterElement.getAttribute('xmpDM:value')
      };
   };

   var parseParameters = function (parametersElement) {
      if (parametersElement) {
         var parameterElements = _xmlUtility.getElementsByTagNameNSPrefix(parametersElement, 'rdf:li');
         var parameters = _.map(parameterElements, parseParameter);
         return parameters;
      }

      return undefined;
   };

   var parseContentListItems = function (contentListItemElements) {
      if (contentListItemElements) {
         var items = _.map(contentListItemElements, function (itemElement) {
            return {
               name: itemElement.getAttribute('xmpDM:name'),
               value: itemElement.getAttribute('xmpDM:value')
            };
         });
         return items;
      }

      return undefined;
   };

   var createFromXmpElement = function (contentListElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);
      if (contentListElement) {
         var contentListItemElements = _xmlUtility.getElementsByTagNameNSPrefix(contentListElement, 'rdf:li');

         var params = {
            items: parseContentListItems(contentListItemElements)
         };
         return new ContentList(params);
      }

      return undefined;
   };

   tscme.ContentList = {
      /**
       *  Factory method that returns a new ContentList object.
       *  @function create
       *  @param {Object} params - Required params for contentList
       *  @param {Object[]} [params.items] - Array of content list items.
       *  @static
       *  @return {tscme.ContentList} new ContentList instance
       */
      create: function (params) {
         return new ContentList(params);
      },

      /**
       *  Factory method that returns a new ContentList object from an XMP contentList element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP contentList element.
       *  @static
       *  @return {tscme.ContentList} new ContentList instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);


(function (tscme, _) {
   'use strict';

   var _xmlUtility;
   var getXmlUtility = function() {

      return _xmlUtility || (_xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver));
   };
   
   var Controller = function (params) {

      var _name;
      var _parameters;
      var _controllerTextItems;
      var _additionalParamProperties = {};

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'name') {
               _name = params.name;
            } else if (key === 'parameters') {
               _parameters = params.parameters;
            } else if (key === 'controllerTextItems') {
               _controllerTextItems = params.controllerTextItems;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var localizedTextTree = _.map(_controllerTextItems, function (item) {
            return {
               'name': 'rdf:li',
               'children': [
                  {
                     name: 'rdf:Description',
                     atts: {
                        'xmp:label': item.label
                     },
                     children: [
                        {
                           name: 'tscDM:localizedText',
                           children: [
                              {
                                 name: 'rdf:Alt',
                                 children: _.map(item.localizedTexts, function(localizedText) {
                                    return {
                                       name: 'rdf:li',
                                       atts: {
                                          'xml:lang': localizedText.lang
                                       },
                                       text: localizedText.text
                                    };
                                 })
                              }
                           ]
                        }
                     ]
                  }
               ]
            };
         });

         var treeDesc = {
            'name': 'tscDM:controller',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:name': _name
                  },
                  'children': [
                     {
                        'name': 'tscDM:parameters',
                        'children': [
                           {
                              'name': 'rdf:Bag',
                              'children': _.map(_parameters, function(param) {
                                 return {
                                    name: 'rdf:li',
                                    atts: {
                                       'xmpDM:name': param.name,
                                       'xmpDM:value': param.value
                                    }
                                 };
                              })
                           }
                        ]
                     },
                     {
                        'name': 'tscDM:controllerText',
                        'children': [
                           {
                              name: 'rdf:Bag',
                              children: localizedTextTree
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return  getXmlUtility().createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            name: {
               get: function () {
                  return _name;
               }
            },
            parameters: {
               get: function () {
                  return _parameters;
               }
            },
            controllerTextItems: {
               get: function () {
                  return _controllerTextItems;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            name: _name,
            parameters: _parameters,
            controllerTextItems: _controllerTextItems
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var parseParameter = function (parameterElement) {
      return {
         name: parameterElement.getAttribute('xmpDM:name'),
         value: parameterElement.getAttribute('xmpDM:value')
      };
   };

   var parseParameters = function (parametersElement) {
      if (parametersElement) {
         var parameterElements = getXmlUtility().getElementsByTagNameNSPrefix(parametersElement, 'rdf:li');
         var parameters = _.map(parameterElements, parseParameter);
         return parameters;
      }

      return undefined;
   };

   var parseLocalizedTextItem = function (textElement) {
      if (textElement) {
         return {
            lang: textElement.getAttribute('xml:lang'),
            text: getXmlUtility().getElementText(textElement)
         };
      }

      return undefined;
   };

   var parseControllerText = function (controllerTextItemElement) {
      var textElements = getXmlUtility().getElementsByTagNameNSPrefix(controllerTextItemElement, 'rdf:li');
      return {
         label: controllerTextItemElement.getAttribute('xmp:label'),
         localizedTexts: _.map(textElements, parseLocalizedTextItem)
      };
   };

   var parseControllerTextItems = function (controllerTextElement) {
      if (controllerTextElement) {
         var controllerTextElements = getXmlUtility().getElementsByTagNameNSPrefix(controllerTextElement, 'rdf:Description');
         var controllerTextItems = _.map(controllerTextElements, parseControllerText);
         return controllerTextItems;
      }

      return undefined;
   };

   var createFromXmpElement = function (controllerElement) {
      if (controllerElement) {
         var descriptionElement = getXmlUtility().getFirstElementByTagNameNSPrefix(controllerElement, 'rdf:Description');
         var parametersElement = getXmlUtility().getFirstElementByTagNameNSPrefix(descriptionElement, 'tscDM:parameters');
         var controllerTextElement = getXmlUtility().getFirstElementByTagNameNSPrefix(descriptionElement, 'tscDM:controllerText');

         var params = {
            name: descriptionElement.getAttribute('xmpDM:name'),
            parameters: parseParameters(parametersElement),
            controllerTextItems: parseControllerTextItems(controllerTextElement)
         };
         return new Controller(params);
      }

      return undefined;
   };

   tscme.Controller = {
      /**
       *  Factory method that returns a new Controller object.
       *  @function create
       *  @param {Object} params - Required params for controller
       *  @param {String} [params.name] - Controller label.
       *  @param {Object[]} [params.parameters] - Array of Objects with name and value properties.
       *  @param {Object[]} [params.controllerTextItems] - Array of localized controller text items.
       *  @static
       *  @return {tscme.Controller} new Controller instance
       */
      create: function (params) {
         return new Controller(params);
      },

      /**
       *  Factory method that returns a new Controller object from an XMP controller element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP controller element.
       *  @static
       *  @return {tscme.Controller} new Controller instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);


(function (tscme, _) {
   'use strict';

   var Hotspot = function (params) {

      var _label;
      var _startTime;
      var _duration;
      var _boundingPoly;
      var _rotate;
      var _pause;
      var _jumpTime;
      var _location;
      var _newWindow;
      var _jumpFile;
      var _file;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'label') {
               _label = params.label;
            } else if (key === 'startTime') {
               _startTime = params.startTime;
            } else if (key === 'duration') {
               _duration = params.duration;
            } else if (key === 'boundingPoly') {
               _boundingPoly = params.boundingPoly;
            } else if (key === 'rotate') {
               _rotate = params.rotate;
            } else if (key === 'pause') {
               _pause = params.pause;
            } else if (key === 'jumpTime') {
               _jumpTime = params.jumpTime;
            } else if (key === 'location') {
               _location = params.location;
            } else if (key === 'newWindow') {
               _newWindow = params.newWindow;
            } else if (key === 'jumpFile') {
               _jumpFile = params.jumpFile;
            } else if (key === 'file') {
               _file = params.file;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:label': _label,
                     'xmpDM:duration': _duration,
                     'xmpDM:startTime': _startTime,
                     'tscDM:boundingPoly': _boundingPoly ? _boundingPoly.toXmpAtt() : undefined,
                     'tscDM:rotate': _rotate,
                     'tscHS:pause': _pause ? '1': '0',
                     'tscHS:jumpTime': _jumpTime,
                     'tscHS:jumpFile': _jumpFile,
                     'xmpDM:location': _location,
                     'tscDM:file': _file,
                     'tscHS:newWindow': _newWindow ? '1' : '0'
                  }
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            label: {
               get: function () {
                  return _label;
               }
            },
            startTime: {
               get: function () {
                  return _startTime;
               }
            },
            endTime: {
               get: function() {
                  return _startTime + _duration;
               }
            },
            duration: {
               get: function () {
                  return _duration;
               }
            },
            boundingPoly: {
               get: function () {
                  return _boundingPoly;
               }
            },
            rotate: {
               get: function () {
                  return _rotate;
               }
            },
            pause: {
               get: function () {
                  return _pause;
               }
            },
            jumpTime: {
               get: function () {
                  return _jumpTime;
               }
            },
            location: {
               get: function () {
                  return _location;
               }
            },
            newWindow: {
               get: function () {
                  return _newWindow;
               }
            },
            jumpFile: {
               get: function() {
                  return _jumpFile;
               }
            },
            file: {
               get: function() {
                  return _file;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            label: _label,
            startTime: _startTime,
            duration: _duration,
            boundingPoly: _boundingPoly,
            rotate: _rotate,
            pause: _pause,
            jumpTime: _jumpTime,
            location: _location,
            newWindow: _newWindow,
            jumpFile: _jumpFile,
            file: _file
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (hotspotElement) {
      var params = {
         label: hotspotElement.getAttribute('xmp:label'),
         startTime: Number(hotspotElement.getAttribute('xmpDM:startTime')),
         duration: Number(hotspotElement.getAttribute('xmpDM:duration')),
         boundingPoly: tscme.BoundingPoly.create(hotspotElement.getAttribute('tscDM:boundingPoly')),
         rotate: Number(hotspotElement.getAttribute('tscDM:rotate')),
         pause: hotspotElement.getAttribute('tscHS:pause') === '1',
         newWindow: hotspotElement.getAttribute('tscHS:newWindow') === '1'
      };

      if (hotspotElement.getAttribute('tscHS:jumpTime')) {
         params.jumpTime = Number(hotspotElement.getAttribute('tscHS:jumpTime'));
      }

      params.jumpFile = hotspotElement.getAttribute('tscHS:jumpFile') || undefined;

      params.location = hotspotElement.getAttribute('xmpDM:location') || undefined;

      params.file = hotspotElement.getAttribute('tscDM:file') || undefined;

      return new Hotspot(params);
   };

   tscme.Hotspot = {
      /**
       *  Factory method that returns a new Hotspot object.
       *  @function create
       *  @param {Object} params - Required params for hotspot
       *  @param {String} [params.label] - Hotspot label.
       *  @param {Number} [params.startTime] - Start time of hotspot (milliseconds).
       *  @param {Number} [params.duration] - Duration of hotspot (milliseconds).
       *  @param {tscme.BoundingPoly} [params.boundingPoly] - Bounding polygon of hotspot.
       *  @param {Number} [params.rotate] - Rotation value of polygon.
       *  @param {Boolean} [params.pause] - Boolean if hotspot should pause at end.
       *  @param {Number} [params.jumpTime] - Specific time within video that hotspot will jump to (milliseconds)
       *  @param {Number} [params.jumpTime] - Specific time within video that hotspot will jump to (milliseconds)
       *  @param {String} [params.location] - URL to launch for hotspot.
       *  @param {Boolean} [params.newWindow] - True if the hotspot location should open in a new window.
       *  @param {String} [params.jumpFile] - Url to file.
       *  @param {String} [params.file] - Url to file.
       *  @static
       *  @return {tscme.Hotspot} new Hotspot instance
       */
      create: function (params) {
         return new Hotspot(params);
      },

      /**
       *  Factory method that returns a new Hotspot object from an XMP hotspot element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP hotspot element.
       *  @static
       *  @return {tscme.Hotspot} new Hotspot instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);


(function (tscme, _) {
   'use strict';

   var HotspotTrack = function (params) {

      var _hotspots = [];
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         if (params.hasOwnProperty('hotspots') && _.isArray(params.hotspots)) {
            _hotspots = params.hotspots;
         } else {
            throw(new Error('HotspotTrack params is expecting an object eg. { hotspots: [hotspot1Object, ...] }'));
         }
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:trackType': 'Hotspot',
                     'xmpDM:trackName': 'Hotspots',
                     'xmpDM:frameRate': 'f1000'
                  },
                  'children': [
                     {
                        name: 'xmpDM:markers',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _hotspots
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            hotspots: {
               get: function () {
                  return _hotspots;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function() {
         var pojo = {
            hotspots: _.invokeMap(_hotspots, 'toPOJO')
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (hotspotTrackElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var hotspotTrack = new HotspotTrack();

      if (hotspotTrackElement) {
         var hotspotElements = _xmlUtility.getElementsByTagNameNSPrefix(hotspotTrackElement, 'rdf:Description');
         var hotspots = _.map(hotspotElements, tscme.Hotspot.createFromXmpElement);

         var params = {
            hotspots: hotspots
         };

         hotspotTrack = new HotspotTrack(params);
      }

      return hotspotTrack;
   };

   tscme.HotspotTrack = {
      /**
       *  Factory method that returns a new HotspotTrack object.
       *  @function create
       *  @param {Object} params - Optional params for caption track
       *  @param {tscme.Hotspot[]} [params.hotspots] - Array of hotspots.
       *  @static
       *  @return {tscme.HotspotTrack} new HotspotTrack instance
       */
      create: function (params) {
         return new HotspotTrack(params);
      },

      /**
       *  Factory method that returns a new HotspotTrack object from an XMP hotspot track element.
       *  @function create
       *  @param {Object} element - XMP hotspot track element.
       *  @static
       *  @return {tscme.HotspotTrack} new HotspotTrack instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);


(function (tscme, _) {
   'use strict';

   var ImageRectangle = function (propertyInfo) {

      var _x;
      var _y;
      var _width;
      var _height;

      if (_.isString(propertyInfo)) {
         var tokens = propertyInfo.split(',');
         _x = Number(tokens[0]);
         _y = Number(tokens[1]);
         _width = Number(tokens[2]);
         _height = Number(tokens[3]);
      } else if (_.isObject(propertyInfo)) {
         _x = propertyInfo.x;
         _y = propertyInfo.y;
         _width = propertyInfo.width;
         _height = propertyInfo.height;
      } else {
         throw(new Error('ImageRectangle is expecting a rectangle property string format: "x, y, width, height"'));
      }

      var _public = Object.defineProperties({},
         {
            x: {
               get: function () {
                  return _x;
               }
            },
            y: {
               get: function () {
                  return _y;
               }
            },
            width: {
               get: function () {
                  return _width;
               }
            },
            height: {
               get: function () {
                  return _height;
               }
            }
         });

      _public.toPOJO = function () {
         return {
            x: _x,
            y: _y,
            width: _width,
            height: _height
         };
      };

      _public.toXmpAtt = function () {
         return [_x, _y, _width, _height].join(', ');
      };

      return _public;
   };

   tscme.ImageRectangle = {
      /**
       *  Factory method that returns a new ImageRectangle object.
       *  @function create
       *  @param {String|Object} propertyInfo - Required property string of the rectangle. A Rectangle object
       *  is an area defined by its position, as indicated by its top-left corner point (x, y) and by its width
       *  and its height. The properties should be comma separated in the following format "x, y, width, height".  Alternatively,
       *  this can be an object containing x,y,width,height properties (i.e. the object that comes out from .toPOJO())
       *  @static
       *  @return {tscme.ImageRectangle} new ImageRectangle instance
       */
      create: function (propertyInfo) {
         return new ImageRectangle(propertyInfo);
      }
   };
})(tscme, _);


(function (tscme, _) {
   'use strict';
   
   var Answer = function (params) {

      var _orderId;
      var _text;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'orderId') {
               _orderId = params.orderId;
            } else if (key === 'text') {
               _text = params.text;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'tscIQ:orderId': _orderId
                  },
                  'children': [
                     {
                        name: 'tscIQ:answer',
                        text: _text
                     }
                  ]
               }
            ]
         };
         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            orderId: {
               get: function () {
                  return _orderId;
               }
            },
            text: {
               get: function () {
                  return _text;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            orderId: _orderId,
            text: _text
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (answerElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);
      
      var answerText = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(answerElement, 'tscIQ:answer');
      var params = {
         orderId: Number(answerElement.getAttribute('tscIQ:orderId')),
         text: answerText
      };
      return new Answer(params);
   };

   tscme.Answer = {
      /**
       *  Factory method that returns a new Answer object.
       *  @function create
       *  @param {Object} params - Required params for answer
       *  @param {Number} [params.orderId] - Answer order id.
       *  @param {String} [params.text] - Answer text.
       *  @static
       *  @return {tscme.Answer} new Answer instance
       */
      create: function (params) {
         return new Answer(params);
      },

      /**
       *  Factory method that returns a new Answer object from an XMP answer element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP answer element.
       *  @static
       *  @return {tscme.Answer} new Answer instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);


(function (tscme, _) {
   'use strict';

   var Feedback = function (params) {

      var _reason;
      var _jumpToTime;
      var _location;
      var _text;
      var _plainText;
      var _markupText;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'reason') {
               _reason = params.reason;
            } else if (key === 'text') {
               _text = params.text;
               _plainText = tscme.Rtf.toText(_text);
               _markupText = tscme.Rtf.toHtml(_text);
            } else if (key === 'jumpToTime') {
               _jumpToTime = params.jumpToTime;
            } else if (key === 'location') {
               _location = params.location;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'tscIQ:reason': _reason,
                     'tscIQ:jumpToTime': _jumpToTime,
                     'tscIQ:location': _location
                  },
                  'children': [
                     {
                        name: 'xmpDM:name',
                        'children': [
                           {
                              name: 'rdf:Alt',
                              // todo: according to the latest branch this is now a language collection of strings
                              // for now i hardcoded a single english version to match the expected output
                              'children': [
                                 {
                                    name: 'rdf:li',
                                    'atts': {
                                       'xml:lang': 'en-US'
                                    },
                                    text: _text
                                 }
                              ]
                           }
                        ]
                     }
                  ]
               }
            ]
         };
         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            reason: {
               get: function () {
                  return _reason;
               }
            },
            jumpToTime: {
               get: function () {
                  return _jumpToTime;
               }
            },
            location: {
               get: function () {
                  return _location;
               }
            },
            text: {
               get: function () {
                  return _text;
               }
            },
            plainText: {
               get: function () {
                  return _plainText;
               }
            },
            markupText: {
               get: function () {
                  return _markupText;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            reason: _reason,
            jumpToTime: _jumpToTime,
            location: _location,
            text: _text,
            plainText: _plainText,
            markupText: _markupText
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (feedbackElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);
      
      var feedbackText = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(feedbackElement, 'rdf:li');
      var params = {
         reason: feedbackElement.getAttribute('tscIQ:reason'),
         text: feedbackText
      };

      if (feedbackElement.getAttribute('tscIQ:jumpToTime')) {
         params.jumpToTime = Number(feedbackElement.getAttribute('tscIQ:jumpToTime'));
      }

      params.location = feedbackElement.getAttribute('tscIQ:location') || undefined;

      return Feedback(params);
   };

   tscme.Feedback = {
      /**
       *  Factory method that returns a new Feedback object.
       *  @function create
       *  @param {Object} params - Required params for feedback
       *  @param {String} [params.reason] - Feedback reason type.
       *  @param {String} [params.text] - Feedback text.
       *  @param {Number} [params.jumpToTime] - Feedback jumpToTime.
       *  @param {String} [params.location] - Feedback location.
       *  @static
       *  @return {tscme.Feedback} new Feedback instance
       */
      create: function (params) {
         return Feedback(params);
      },

      /**
       *  Factory method that returns a new Feedback object from an XMP feedback element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP feedback element.
       *  @static
       *  @return {tscme.Feedback} new Feedback instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var Question = function (params) {

      var _id;
      var _type;
      var _text;
      var _correctAnswer;
      var _answers = [];
      var _feedback = [];
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'id') {
               _id = params.id;
            } else if (key === 'type') {
               _type = params.type;
            } else if (key === 'text') {
               _text = params.text;
            } else if (key === 'correctAnswer') {
               _correctAnswer = params.correctAnswer;
            } else if (key === 'answers') {
               _answers = params.answers;
            } else if (key === 'feedback') {
               _feedback = params.feedback;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'tscIQ:id': _id,
                     'tscIQ:type': _type
                  },
                  'children': [
                     {
                        name: 'tscIQ:question',
                        text: _text
                     },
                     {
                        name: 'tscIQ:correctAnswer',
                        text: _type === 'MC' ? _correctAnswer : null
                     },
                     {
                        name: 'tscIQ:answerArray',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _answers
                           }
                        ]
                     },
                     {
                        name: 'tscIQ:feedback',
                        children: [
                           {
                              name: 'rdf:Bag',
                              children: _feedback
                           }
                        ]
                     }
                  ]
               }
            ]
         };
         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            id: {
               get: function () {
                  return _id;
               }
            },
            type: {
               get: function () {
                  return _type;
               }
            },
            text: {
               get: function () {
                  return _text;
               }
            },
            correctAnswer: {
               get: function () {
                  return _correctAnswer;
               }
            },
            answers: {
               get: function () {
                  return _answers;
               }
            },
            feedback: {
               get: function() {
                  return _feedback;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            id: _id,
            type: _type,
            text: _text,
            correctAnswer: _correctAnswer,
            answers: _.invokeMap(_answers, 'toPOJO'),
            feedback: _feedback !== undefined ? _.invokeMap(_feedback, 'toPOJO') : undefined
         };

         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (questionElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);
      
      var text = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(questionElement, 'tscIQ:question');
      var correctAnswerText = _xmlUtility.getFirstChildElementTextByTagNameNSPrefix(questionElement, 'tscIQ:correctAnswer');

      var descriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(questionElement, 'rdf:Description');
      var answerElements = _.filter(descriptionElements, function (element) {
         return _xmlUtility.hasAttribute(element, 'tscIQ:orderId');
      });
      var answers = _.map(answerElements, tscme.Answer.createFromXmpElement);

      var feedbackElements = _.filter(descriptionElements, function (element) {
         return _xmlUtility.hasAttribute(element, 'tscIQ:reason');
      });

      var feedback = _.map(feedbackElements, tscme.Feedback.createFromXmpElement);

      var params = {
         id: Number(questionElement.getAttribute('tscIQ:id')),
         type: questionElement.getAttribute('tscIQ:type'),
         text: text,
         correctAnswer: correctAnswerText ? Number(correctAnswerText) : undefined,
         answers: answers,
         feedback: feedback
      };

      return Question(params);
   };

   tscme.Question = {
      /**
       *  Factory method that returns a new Question object.
       *  @function create
       *  @param {Object} params - Required params for question
       *  @param {Number} [params.id] - Question id.
       *  @param {String} [params.text] - Question text.
       *  @param {Number} [params.correctAnswer] - Index of the correct answer within answer array (1 based).
       *  @param {tscme.Answer[]} [params.answers] - Question answer array.
       *  @param {tscme.Feedback[]} [params.feedback] - Question feedback array.
       *  @static
       *  @return {tscme.Question} new Question instance
       */
      create: function (params) {
         return Question(params);
      },

      /**
       *  Factory method that returns a new Question object from an XMP question element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP question element.
       *  @static
       *  @return {tscme.Question} new Question instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var QuestionSet = function (params) {

      var _name;
      var _feedback;
      var _startTime;
      var _questions;
      var _file;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'name') {
               _name = params.name;
            } else if (key === 'feedback') {
               _feedback = params.feedback;
            } else if (key === 'startTime') {
               _startTime = params.startTime;
            } else if (key === 'file') {
               _file = params.file;
            } else if (key === 'questions') {
               _questions = params.questions;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'tscIQ:questionSetName': _name,
                     'tscIQ:feedback': _feedback ? '1' : '0',
                     'tscDM:file': _file,
                     'xmpDM:startTime': _startTime
                  },
                  'children': [
                     {
                        name: 'tscIQ:questions',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _questions
                           }
                        ]
                     }
                  ]
               }
            ]
         };
         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
      {
         name: {
            get: function () {
               return _name;
            }
         },
         feedback: {
            get: function () {
               return _feedback;
            }
         },
         startTime: {
            get: function () {
               return _startTime;
            }
         },
         file: {
            get: function() {
               return _file;
           }
         },
         questions: {
            get: function () {
               return _questions;
            }
         }
      });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            name: _name,
            feedback: _feedback,
            startTime: _startTime,
            file: _file,
            questions: _.invokeMap(_questions, 'toPOJO')
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (questionSetElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);
      
      var descriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(questionSetElement, 'rdf:Description');
      var questionElements = _.filter(descriptionElements, function (element) {
         return _xmlUtility.hasAttribute(element, 'tscIQ:type');
      });

      var questions = _.map(questionElements, tscme.Question.createFromXmpElement);
      var params = {
         name: questionSetElement.getAttribute('tscIQ:questionSetName'),
         feedback: questionSetElement.getAttribute('tscIQ:feedback') === '1',
         startTime: Number(questionSetElement.getAttribute('xmpDM:startTime')),
         questions: questions
      };

      params.file = questionSetElement.getAttribute('tscDM:file') || undefined;

      return new QuestionSet(params);
   };

   tscme.QuestionSet = {
      /**
       *  Factory method that returns a new QuestionSet object.
       *  @function create
       *  @param {Object} params - Required params for question set
       *  @param {String} [params.questionsSetName] - Question set name.
       *  @param {Boolean} [params.feedback] - Question set feedback.
       *  @param {Number} [params.startTime] - Question set start time (milliseconds)
       *  @param {String} [params.file] - Associated file
       *  @param {tscme.Question[]} [params.questions] - Question set questions.
       *  @static
       *  @return {tscme.QuestionSet} new QuestionSet instance
       */
      create: function (params) {
         return new QuestionSet(params);
      },

      /**
       *  Factory method that returns a new QuestionSet object from an XMP questionSet element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP questionSet element.
       *  @static
       *  @return {tscme.QuestionSet} new QuestionSet instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var QuizTrack = function (params) {

      var _quizGuid;
      var _authoredEmail;
      var _requireUserId;
      var _locale;
      var _reportMethod;
      var _clientId;
      var _quizHash;
      var _hideReplay;
      var _allowSkipQuiz;
      var _questionSets = [];
      var _parameters;
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key ==='quizGuid') {
               _quizGuid = params.quizGuid;
            } else if (key ==='authoredEmail') {
               _authoredEmail = params.authoredEmail;
            } else if (key ==='requireUserId') {
               _requireUserId = params.requireUserId;
            } else if (key ==='locale') {
               _locale = params.locale;
            } else if (key ==='reportMethod') {
               _reportMethod = params.reportMethod;
            } else if (key ==='clientId') {
               _clientId = params.clientId;
            } else if (key ==='quizHash') {
               _quizHash = params.quizHash;
            } else if (key ==='hideReplay') {
               _hideReplay = params.hideReplay;
            } else if (key ==='allowSkipQuiz') {
               _allowSkipQuiz = params.allowSkipQuiz;
            } else if (key ==='parameters' && _.isArray(params.parameters)) {
               _parameters = params.parameters;
            } else if (key ==='questionSets' && _.isArray(params.questionSets)) {
               _questionSets = params.questionSets;
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:trackType': 'Quiz',
                     'xmpDM:trackName': 'Quiz',
                     'xmpDM:frameRate': 'f1000',
                     'tscIQ:clientId': _clientId,
                     'tscIQ:quizHash': _quizHash,
                     'tscIQ:quizGuid': _quizGuid,
                     'tscIQ:authoredEmail': _authoredEmail,
                     'tscIQ:requireUserId': _requireUserId ? '1' : '0',
                     'tscIQ:locale': _locale,
                     'tscIQ:reportMethod': _reportMethod,
                     'tscIQ:hideReplay': _hideReplay ? '1' : '0',
                     'tscIQ:allowSkipQuiz': _allowSkipQuiz ? '1' : '0'
                  },
                  'children': [
                     {
                        name: 'xmpDM:markers',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _questionSets
                           }
                        ]
                     },
                     {
                        'name': 'tscIQ:QuizParams',
                        'children': [
                           {
                              'name': 'rdf:Bag',
                              'children': _.map(_parameters, function(param) {
                                 return {
                                    name: 'rdf:li',
                                    atts: {
                                       'xmpDM:name': param.name,
                                       'xmpDM:value': param.value
                                    }
                                 };
                              })
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            quizGuid: {
               get: function () {
                  return _quizGuid;
               }
            },
            authoredEmail: {
               get: function () {
                  return _authoredEmail;
               }
            },
            requireUserId: {
               get: function () {
                  return _requireUserId;
               }
            },
            locale: {
               get: function () {
                  return _locale;
               }
            },
            reportMethod: {
               get: function () {
                  return _reportMethod;
               }
            },
            clientId: {
               get: function () {
                  return _clientId;
               }
            },
            quizHash: {
               get: function () {
                  return _quizHash;
               }
            },
            hideReplay: {
               get: function () {
                  return _hideReplay;
               }
            },
            allowSkipQuiz: {
               get: function () {
                  return _allowSkipQuiz;
               }
            },
            parameters: {
               get: function () {
                  return _parameters;
               }
            },
            questionSets: {
               get: function () {
                  return _questionSets;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function() {
         var pojo = {
            quizGuid: _quizGuid,
            authoredEmail: _authoredEmail,
            requireUserId: _requireUserId,
            locale: _locale,
            reportMethod: _reportMethod,
            clientId: _clientId,
            quizHash: _quizHash,
            hideReplay: _hideReplay,
            allowSkipQuiz: _allowSkipQuiz,
            questionSets: _.invokeMap(_questionSets, 'toPOJO'),
            parameters: _parameters || undefined
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         return pojo;
      };

      return _public;
   };

   var parseParameter = function (parameterElement) {
      return {
         name: parameterElement.getAttribute('xmpDM:name'),
         value: parameterElement.getAttribute('xmpDM:value')
      };
   };

   var parseParameters = function (quizParametersElement, xmlUtility) {
      if (quizParametersElement) {
         var parameterElements = xmlUtility.getElementsByTagNameNSPrefix(quizParametersElement, 'rdf:li');
         var parameters = _.map(parameterElements, parseParameter);
         return parameters;
      }

      return undefined;
   };

   var createFromXmpElement = function (quizTrackElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var quizTrack = new QuizTrack();

      if (quizTrackElement) {
         var descriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(quizTrackElement, 'rdf:Description');
         var questionSetElements = _.filter(descriptionElements, function (element) {
            return _xmlUtility.hasAttribute(element, 'tscIQ:questionSetName');
         });
         var questionSets = _.map(questionSetElements, tscme.QuestionSet.createFromXmpElement);

         var quizParametersElement = _xmlUtility.getFirstElementByTagNameNSPrefix(quizTrackElement, 'tscIQ:QuizParams');

         var params = {
            quizGuid: quizTrackElement.getAttribute('tscIQ:quizGuid'),
            authoredEmail: quizTrackElement.getAttribute('tscIQ:authoredEmail'),
            requireUserId: quizTrackElement.getAttribute('tscIQ:requireUserId') === '1',
            locale: quizTrackElement.getAttribute('tscIQ:locale'),
            reportMethod: quizTrackElement.getAttribute('tscIQ:reportMethod'),
            clientId: quizTrackElement.getAttribute('tscIQ:clientId'),
            quizHash: quizTrackElement.getAttribute('tscIQ:quizHash'),
            hideReplay: quizTrackElement.getAttribute('tscIQ:hideReplay') === '1',
            allowSkipQuiz: (quizTrackElement.getAttribute('tscIQ:allowSkipQuiz') === '0') ? false : true,
            parameters: parseParameters(quizParametersElement, _xmlUtility),
            questionSets: questionSets
         };

         quizTrack = new QuizTrack(params);
      }

      return quizTrack;
   };

   tscme.QuizTrack = {
      /**
       *  Factory method that returns a new QuizTrack object.
       *  @function create
       *  @param {Object} params - Optional params for caption track
       *  @param {tscme.QuestionSet[]} [params.questionSets] - Array of question sets.
       *  @static
       *  @return {tscme.QuizTrack} new QuizTrack instance
       */
      create: function (params) {
         return new QuizTrack(params);
      },

      /**
       *  Factory method that returns a new QuizTrack object from an XMP quiz track element.
       *  @function create
       *  @param {Object} element - XMP quiz track element.
       *  @static
       *  @return {tscme.QuizTrack} new QuizTrack instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var ScreenTextMarker = function (params) {

      var _name;
      var _startTime;
      var _duration;
      var _tableOfContentsEntry;
      var _image;
      var _imageIndex;
      var _imageOffset;
      var _imageRectangle;
      var _file;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'name') {
               _name = params.name;
            } else if (key === 'startTime') {
               _startTime = params.startTime;
            } else if (key === 'duration') {
               _duration = params.duration;
            } else if (key === 'tableOfContentsEntry') {
               _tableOfContentsEntry = params.tableOfContentsEntry;
            } else if (key === 'image') {
               _image = params.image;
            } else if (key === 'imageIndex') {
               _imageIndex = params.imageIndex;
            } else if (key === 'imageOffset') {
               _imageOffset = params.imageOffset;
            } else if (key === 'imageRectangle') {
               _imageRectangle = params.imageRectangle;
            } else if (key === 'file') {
               _file = params.file;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:name': _name,
                     'xmpDM:startTime': _startTime,
                     'xmpDM:duration': _duration,
                     'tscDM:tocEntry': _tableOfContentsEntry,
                     'tscDM:image': _image,
                     'tscDM:imageindex': _imageIndex,
                     'tscDM:imageoffset': _imageOffset,
                     'tscDM:imagerect': _imageRectangle ? _imageRectangle.toXmpAtt() : null,
                     'tscDM:file': _file
                  }
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            name: {
               get: function () {
                  return _name;
               }
            },
            startTime: {
               get: function () {
                  return _startTime;
               }
            },
            duration: {
               get: function () {
                  return _duration;
               }
            },
            tableOfContentsEntry: {
               get: function () {
                  return _tableOfContentsEntry;
               }
            },
            image: {
               get: function () {
                  return _image;
               }
            },
            imageIndex: {
               get: function () {
                  return _imageIndex;
               }
            },
            imageOffset: {
               get: function () {
                  return _imageOffset;
               }
            },
            imageRectangle: {
               get: function () {
                  return _imageRectangle;
               }
            },
            file: {
               get: function () {
                  return _file;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            name: _name,
            startTime: _startTime,
            duration: _duration,
            tableOfContentsEntry: _tableOfContentsEntry,
            image: _image,
            imageIndex: _imageIndex,
            imageOffset: _imageOffset,
            imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : _imageRectangle,
            file: _file
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (screenTextMarkerElement) {
      var params = {
         name: screenTextMarkerElement.getAttribute('xmpDM:name'),
         startTime: Number(screenTextMarkerElement.getAttribute('xmpDM:startTime')),
         duration: Number(screenTextMarkerElement.getAttribute('xmpDM:duration'))
      };

      // optional attributes below

      if (screenTextMarkerElement.getAttribute('tscDM:tocEntry')) {
         params.tableOfContentsEntry = Number(screenTextMarkerElement.getAttribute('tscDM:tocEntry'));
      }

      params.image = screenTextMarkerElement.getAttribute('tscDM:image') || undefined;

      if (screenTextMarkerElement.getAttribute('tscDM:imageindex')) {
         params.imageIndex = Number(screenTextMarkerElement.getAttribute('tscDM:imageindex'));
      }

      if (screenTextMarkerElement.getAttribute('tscDM:imageoffset')) {
         params.imageOffset = Number(screenTextMarkerElement.getAttribute('tscDM:imageoffset'));
      }

      if (screenTextMarkerElement.getAttribute('tscDM:imagerect')) {
         params.imageRectangle = tscme.ImageRectangle.create(screenTextMarkerElement.getAttribute('tscDM:imagerect'));
      }

      params.file = screenTextMarkerElement.getAttribute('tscDM:file') || undefined;

      return new ScreenTextMarker(params);
   };

   tscme.ScreenTextMarker = {
      /**
       *  Factory method that returns a new ScreenTextMarker object.
       *  @function create
       *  @param {Object} params - Required params for table of contents item
       *  @param {String} [params.name] - ScreenText marker name.
       *  @param {Number} [params.startTime] - Start time of the screenText marker (milliseconds).
       *  @param {Number} [params.duration] - Duration of the screenText marker (milliseconds).
       *  @param {String} [params.tableOfContentsEntry] - Index of the table of contents entry corresponding to this screen text marker.
       *  @param {String} [params.image] - ScreenText marker image.
       *  @param {Number} [params.imageIndex] - ScreenText marker image index.
       *  @param {Number} [params.imageOffset] - ScreenText marker image offset.
       *  @param {tscme.ImageRectangle} [params.imageRectangle] - ScreenText marker image rectangle.
       *  @param {tscme.file} [params.file] - file associated with ScreenText marker.
       *  @static
       *  @return {tscme.ScreenTextMarker} new ScreenTextMarker instance
       */
      create: function (params) {
         return new ScreenTextMarker(params);
      },

      /**
       *  Factory method that returns a new ScreenTextMarker object from an XMP screenText marker element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP screenTextMarker element.
       *  @static
       *  @return {tscme.ScreenTextMarker} new ScreenTextMarker instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var ScreenTextTrack = function (params) {

      var _markers = [];
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         if (params.hasOwnProperty('markers') && _.isArray(params.markers)) {
            _markers = params.markers;
         } else {
            throw(new Error('ScreenTextTrack params is expecting an object eg. { markers: [marker1Object, ...] }'));
         }
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:trackType': 'ScreenText',
                     'xmpDM:trackName': 'Screen Text',
                     'xmpDM:frameRate': 'f1000'
                  },
                  'children': [
                     {
                        name: 'xmpDM:markers',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _markers
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            markers: {
               get: function () {
                  return _markers;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function() {
         var pojo = {
            markers: _.invokeMap(_markers, 'toPOJO')
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (screenTextTrackElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var screenTextTrack = new ScreenTextTrack();

      if (screenTextTrackElement) {
         var markerElements = _xmlUtility.getElementsByTagNameNSPrefix(screenTextTrackElement, 'rdf:Description');
         var markers = _.map(markerElements, tscme.ScreenTextMarker.createFromXmpElement);

         var params = {
            markers: markers
         };

         screenTextTrack = new ScreenTextTrack(params);
      }

      return screenTextTrack;
   };

   tscme.ScreenTextTrack = {
      /**
       *  Factory method that returns a new ScreenTextTrack object.
       *  @function create
       *  @param {Object} params - Optional params for screenText track
       *  @param {tscme.ScreenTextMarker[]} [params.markers] - Array of screenText marker items.
       *  @static
       *  @return {tscme.ScreenTextTrack} new ScreenTextTrack instance
       */
      create: function (params) {
         return new ScreenTextTrack(params);
      },

      /**
       *  Factory method that returns a new ScreenTextTrack object from an XMP screenText track element.
       *  @function create
       *  @param {Object} element - XMP screenText track element.
       *  @static
       *  @return {tscme.ScreenTextTrack} new ScreenTextTrack instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var SpeechMarker = function (params) {

      var _startTime;
      var _duration;
      var _name;
      var _probability;
      var _image;
      var _imageIndex;
      var _imageOffset;
      var _file;
      var _imageRectangle;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'startTime') {
               _startTime = params.startTime;
            } else if (key === 'duration') {
               _duration = params.duration;
            } else if (key === 'name') {
               _name = params.name;
            } else if (key === 'probability') {
               _probability = params.probability;
            } else if (key === 'image') {
               _image = params.image;
            } else if (key === 'imageIndex') {
               _imageIndex = params.imageIndex;
            } else if (key === 'imageOffset') {
               _imageOffset = params.imageOffset;
            } else if (key === 'file') {
               _file = params.file;
            } else if (key === 'imageRectangle') {
               _imageRectangle = params.imageRectangle;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:name': _name,
                     'xmpDM:startTime': _startTime,
                     'xmpDM:duration': _duration,
                     'xmpDM:probability': _probability,
                     'tscDM:image': _image,
                     'tscDM:imageindex': _imageIndex,
                     'tscDM:imageoffset': _imageOffset,
                     'tscDM:imagerect': _imageRectangle ? _imageRectangle.toXmpAtt() : null,
                     'tscDM:file': _file
                  }
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            startTime: {
               get: function () {
                  return _startTime;
               }
            },
            duration: {
               get: function () {
                  return _duration;
               }
            },
            name: {
               get: function () {
                  return _name;
               }
            },
            probability: {
               get: function () {
                  return _probability;
               }
            },
            image: {
               get: function () {
                  return _image;
               }
            },
            imageIndex: {
               get: function () {
                  return _imageIndex;
               }
            },
            imageOffset: {
               get: function () {
                  return _imageOffset;
               }
            },
            file: {
               get: function() {
                  return _file;
               }
            },
            imageRectangle: {
               get: function () {
                  return _imageRectangle;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            startTime: _startTime,
            duration: _duration,
            name: _name,
            probability: _probability,
            image: _image,
            imageIndex: _imageIndex,
            imageOffset: _imageOffset,
            file: _file,
            imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : undefined
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (speechMarkerElement) {
      var params = {
         startTime: Number(speechMarkerElement.getAttribute('xmpDM:startTime')),
         duration: Number(speechMarkerElement.getAttribute('xmpDM:duration')),
         name: speechMarkerElement.getAttribute('xmpDM:name'),
         probability: Number(speechMarkerElement.getAttribute('xmpDM:probability'))
      };

      // optional attributes below

      params.image = speechMarkerElement.getAttribute('tscDM:image') || undefined;

      if (speechMarkerElement.getAttribute('tscDM:imageindex')) {
         params.imageIndex = Number(speechMarkerElement.getAttribute('tscDM:imageindex'));
      }

      if (speechMarkerElement.getAttribute('tscDM:imageoffset')) {
         params.imageOffset = Number(speechMarkerElement.getAttribute('tscDM:imageoffset'));
      }

         params.file = speechMarkerElement.getAttribute('tscDM:file') || undefined;

      if (speechMarkerElement.getAttribute('tscDM:imagerect')) {
         params.imageRectangle = tscme.ImageRectangle.create(speechMarkerElement.getAttribute('tscDM:imagerect'));
      }

      return new SpeechMarker(params);
   };

   tscme.SpeechMarker = {
      /**
       *  Factory method that returns a new SpeechMarker object.
       *  @function create
       *  @param {Object} params - Required params for table of contents item
       *  @param {Number} [params.startTime] - Start time of the speech marker (milliseconds).
       *  @param {Number} [params.duration] - Duration of the speech marker (milliseconds).
       *  @param {String} [params.name] - Speech marker name.
       *  @param {String} [params.image] - Speech marker image.
       *  @param {Number} [params.imageIndex] - Speech marker image index.
       *  @param {Number} [params.imageOffset] - Speech marker image offset.
       *  @param {tscme.ImageRectangle} [params.imageRectangle] - Speech marker image rectangle.
       *  @static
       *  @return {tscme.SpeechMarker} new SpeechMarker instance
       */
      create: function (params) {
         return new SpeechMarker(params);
      },

      /**
       *  Factory method that returns a new SpeechMarker object from an XMP speech marker element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP speechMarker element.
       *  @static
       *  @return {tscme.SpeechMarker} new SpeechMarker instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var SpeechTrack = function (params) {

      var _markers = [];
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         if (params.hasOwnProperty('markers') && _.isArray(params.markers)) {
            _markers = params.markers;
         } else {
            throw(new Error('SpeechTrack params is expecting an object eg. { markers: [marker1Object, ...] }'));
         }
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:trackType': 'Speech',
                     'xmpDM:trackName': 'Speech to Text',
                     'xmpDM:frameRate': 'f1000'
                  },
                  'children': [
                     {
                        name: 'xmpDM:markers',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _markers
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            markers: {
               get: function () {
                  return _markers;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function() {
         var pojo = {
            markers: _.invokeMap(_markers, 'toPOJO')
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (speechTrackElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var speechTrack = new SpeechTrack();

      if (speechTrackElement) {
         var markerElements = _xmlUtility.getElementsByTagNameNSPrefix(speechTrackElement, 'rdf:li');
         var markers = _.map(markerElements, tscme.SpeechMarker.createFromXmpElement);

         var params = {
            markers: markers
         };

         speechTrack = new SpeechTrack(params);
      }

      return speechTrack;
   };

   tscme.SpeechTrack = {
      /**
       *  Factory method that returns a new SpeechTrack object.
       *  @function create
       *  @param {Object} params - Optional params for speech track
       *  @param {tscme.SpeechMarker[]} [params.markers] - Array of speech marker items.
       *  @static
       *  @return {tscme.SpeechTrack} new SpeechTrack instance
       */
      create: function (params) {
         return new SpeechTrack(params);
      },

      /**
       *  Factory method that returns a new SpeechTrack object from an XMP speech track element.
       *  @function create
       *  @param {Object} element - XMP speech track element.
       *  @static
       *  @return {tscme.SpeechTrack} new SpeechTrack instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var TableOfContentsItem = function (params) {

      var _name;
      var _startTime;
      var _image;
      var _imageIndex;
      var _imageOffset;
      var _imageRectangle;
      var _file;
      var _additionalParamProperties = {};
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         _.forEach(_.keys(params), function (key) {
            if (key === 'name') {
               _name = params.name;
            } else if (key === 'startTime') {
               _startTime = params.startTime;
            } else if (key === 'image') {
               _image = params.image;
            } else if (key === 'imageIndex') {
               _imageIndex = params.imageIndex;
            } else if (key === 'imageOffset') {
               _imageOffset = params.imageOffset;
            } else if (key === 'imageRectangle') {
               _imageRectangle = params.imageRectangle;
            } else if (key === 'file') {
               _file = params.file;
            } else if (!_.isFunction(_additionalParamProperties[key])) {
               _additionalParamProperties[key] = params[key];
            }
         });
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:name': _name,
                     'xmpDM:startTime': _startTime,
                     'tscDM:image': _image,
                     'tscDM:imageindex': _imageIndex,
                     'tscDM:imageoffset': _imageOffset,
                     'tscDM:imagerect': _imageRectangle ? _imageRectangle.toXmpAtt() : null,
                     'tscDM:file': _file
                  }
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            name: {
               get: function () {
                  return _name;
               }
            },
            startTime: {
               get: function () {
                  return _startTime;
               }
            },
            image: {
               get: function () {
                  return _image;
               }
            },
            imageIndex: {
               get: function () {
                  return _imageIndex;
               }
            },
            imageOffset: {
               get: function () {
                  return _imageOffset;
               }
            },
            imageRectangle: {
               get: function () {
                  return _imageRectangle;
               }
            },
            file: {
               get: function() {
                  return _file;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function () {
         var pojo = {
            name: _name,
            startTime: _startTime,
            image: _image,
            imageIndex: _imageIndex,
            imageOffset: _imageOffset,
            imageRectangle: _imageRectangle ? _imageRectangle.toPOJO() : undefined,
            file: _file
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         _.forEach(_.keys(_additionalParamProperties), function (key) {
            pojo[key] = _additionalParamProperties[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (tableOfContentsItemElement) {
      var params = {
         name: tableOfContentsItemElement.getAttribute('xmpDM:name'),
         startTime: Number(tableOfContentsItemElement.getAttribute('xmpDM:startTime'))
      };

      // optional attributes below

      params.image = tableOfContentsItemElement.getAttribute('tscDM:image') || undefined;

      if (tableOfContentsItemElement.getAttribute('tscDM:imageindex')) {
         params.imageIndex = Number(tableOfContentsItemElement.getAttribute('tscDM:imageindex'));
      }

      if (tableOfContentsItemElement.getAttribute('tscDM:imageoffset')) {
         params.imageOffset = Number(tableOfContentsItemElement.getAttribute('tscDM:imageoffset'));
      }

      params.file = tableOfContentsItemElement.getAttribute('tscDM:file') || undefined;

      if (tableOfContentsItemElement.getAttribute('tscDM:imagerect')) {
         params.imageRectangle = tscme.ImageRectangle.create(tableOfContentsItemElement.getAttribute('tscDM:imagerect'));
      }

      return new TableOfContentsItem(params);
   };

   tscme.TableOfContentsItem = {
      /**
       *  Factory method that returns a new TableOfContentsItem object.
       *  @function create
       *  @param {Object} params - Required params for table of contents item
       *  @param {String} [params.name] - Table of contents item name.
       *  @param {Number} [params.startTime] - Start time of table of contents item (milliseconds).
       *  @param {String} [params.image] - Table of contents item image.
       *  @param {Number} [params.imageIndex] - Table of contents item image index.
       *  @param {Number} [params.imageOffset] - Table of contents item image offset.
       *  @param {tscme.ImageRectangle} [params.imageRectangle] - Table of contents item image rectangle.
       *  @param {String} [params.file] - File string associated with toc item.
       *  @static
       *  @return {tscme.TableOfContentsItem} new TableOfContentsItem instance
       */
      create: function (params) {
         return new TableOfContentsItem(params);
      },

      /**
       *  Factory method that returns a new TableOfContentsItem object from an XMP tableOfContentsItem element.
       *  @function createFromXmpElement
       *  @param {Object} element - XMP tableOfContentsItem element.
       *  @static
       *  @return {tscme.TableOfContentsItem} new TableOfContentsItem instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var TableOfContentsTrack = function (params) {

      var _items = [];
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      if (params) {
         if (params.hasOwnProperty('items') && _.isArray(params.items)) {
            _items = params.items;
         } else {
            throw(new Error('TableOfContentsTrack params is expecting an object eg. { items: [item1Object, ...] }'));
         }
      }

      var toXmp = function () {
         var treeDesc = {
            'name': 'rdf:li',
            'children': [
               {
                  'name': 'rdf:Description',
                  'atts': {
                     'xmpDM:trackType': 'TableOfContents',
                     'xmpDM:trackName': 'Table of Contents',
                     'xmpDM:frameRate': 'f1000',
                     'tscDM:image': params ? params.image : undefined,
                     'tscDM:tocCellLayout': params ? params.cellLayout : undefined
                  },
                  'children': [
                     {
                        name: 'xmpDM:markers',
                        children: [
                           {
                              name: 'rdf:Seq',
                              children: _items
                           }
                        ]
                     }
                  ]
               }
            ]
         };

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var _public = Object.defineProperties({},
         {
            image: {
               get: function() {
                  return params.image;
               }
            },
            cellLayout: {
               get: function() {
                 return params.cellLayout;
               }
            },
            items: {
               get: function () {
                  return _items;
               }
            }
         });

      _public.toXmp = toXmp;

      _public.toPOJO = function() {
         var pojo = {
            image: params.image,
            cellLayout: params.cellLayout,
            items: _.invokeMap(_items, 'toPOJO')
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         return pojo;
      };

      return _public;
   };

   var createFromXmpElement = function (tableOfContentsTrackElement) {
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var tableOfContentsTrack = new TableOfContentsTrack();

      if (tableOfContentsTrackElement) {
         var tableOfContentsItemElements = _xmlUtility.getElementsByTagNameNSPrefix(tableOfContentsTrackElement, 'rdf:Description');
         var image = tableOfContentsTrackElement.getAttribute('tscDM:image');
         var cellLayout = tableOfContentsTrackElement.getAttribute('tscDM:tocCellLayout');
         var items = _.map(tableOfContentsItemElements, tscme.TableOfContentsItem.createFromXmpElement);

         var params = {
            image: image,
            cellLayout: cellLayout,
            items: items
         };

         tableOfContentsTrack = new TableOfContentsTrack(params);
      }

      return tableOfContentsTrack;
   };

   tscme.TableOfContentsTrack = {
      /**
       *  Factory method that returns a new TableOfContentsTrack object.
       *  @function create
       *  @param {Object} params - Optional params for table of contents track
       *  @param {tscme.TableOfContentsItem[]} [params.items] - Array of table of content items.
       *  @static
       *  @return {tscme.TableOfContentsTrack} new TableOfContentsTrack instance
       */
      create: function (params) {
         return new TableOfContentsTrack(params);
      },

      /**
       *  Factory method that returns a new TableOfContentsTrack object from an XMP table of contents track element.
       *  @function create
       *  @param {Object} element - XMP table of contents track element.
       *  @static
       *  @return {tscme.TableOfContentsTrack} new TableOfContentsTrack instance
       */
      createFromXmpElement: createFromXmpElement
   };
})(tscme, _);

(function (tscme, _) {
   'use strict';

   var _ns = {
      x: 'adobe:ns:meta/',
      xml: 'http://www.w3.org/1999/xhtml',
      rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
      dc: 'http://purl.org/dc/elements/1.1/',
      exif: 'http://ns.adobe.com/exif/1.0',
      stDim: 'http://ns.adobe.com/xap/1.0/sType/Dimensions#',
      stFnt: 'http://ns.adobe.com/xap/1.0/sType/Font#',
      tsc: 'http://www.techsmith.com/xmp/tsc/',
      tscDM: 'http://www.techsmith.com/xmp/tscDM/',
      tscHS: 'http://www.techsmith.com/xmp/tscHS/',
      tscIQ: 'http://www.techsmith.com/xmp/tscIQ/',
      xmp: 'http://ns.adobe.com/xap/1.0/',
      xmpDM: 'http://ns.adobe.com/xmp/1.0/DynamicMedia/',
      xmpG: 'http://ns.adobe.com/xap/1.0/g/',
      xmpMM: 'http://ns.adobe.com/xap/1.0/mm/'
   };

   var _namespaceResolver = function(prefix) {
      return _ns[prefix] || null;
   };

   var Xmp = function (xmpXml) {

      var _version;
      var _title;
      var _date;
      var _creator;
      var _presenterEmail;
      var _description;
      var _source;
      var _about;
      var _keywords;
      var _thumbnail;
      var _firstFrame;
      var _project;
      var _originId;
      var _iPodExplicit;
      var _documentId;
      var _duration;
      var _videoFrameSize;
      var _captionTrack;
      var _hotspotTrack;
      var _tableOfContentsTrack;
      var _quizTrack;
      var _speechTrack;
      var _screenTextTrack;
      var _controller;
      var _contentList;
      var _languages = [];
      var _containsTocThumbnails = false;
      var _containsToc = false;
      var _containsCaptions = false;
      var _containsHotspots = false;
      var _containsQuiz = false;
      var _containsQuizQuestions = false;
      var _containsScreenText = false;
      var _containsSpeechText = false;
      var _xmlUtility = new tscme.NamespaceXmlUtility(tscme.Xmp.namespaceResolver);

      var toXmp = function () {

         var tracksContainer = _.filter([ _captionTrack, _hotspotTrack, _quizTrack, _screenTextTrack, _speechTrack, _tableOfContentsTrack ], function(track){return track !== null;});

         var treeDesc = {
            'name': 'rdf:Description',
            'atts': {
               'tsc:version': _version,
               'dc:title': _title,
               'tscDM:presenteremail': _presenterEmail,
               'dc:source': _source,
               'dc:date': _date,
               'rdf:about': _about,
               'dc:creator': _creator,
               'dc:description': _description,
               'tscDM:keywords': _keywords,
               'tscDM:thumbnail': _thumbnail,
               'tscDM:firstFrame': _firstFrame,
               'tscDM:project': _project,
               'tscDM:originId': _originId,
               'tscDM:iPodExplicit': _iPodExplicit,
               'xmpMM:DocumentID': _documentId
            },
            'children': [
               {
                  name: 'xmpDM:Tracks',
                  children: [
                     {
                        'name': 'rdf:Bag',
                        children: tracksContainer
                     }
                  ]
               },
               {
                  name: 'tscDM:controller',
                  children: [ _controller ]
               },
               {
                  name: 'tscDM:contentList',
                  children: [ _contentList ]
               },
               {
                  'name': 'tsc:langName',
                  'children': [
                     {
                        'name': 'rdf:Bag',
                        'children': _.map(_languages, function(language) {
                           return {
                              name: 'rdf:li',
                              atts: {
                                 'xml:lang': language.langName
                              },
                              text: language.langValue
                           };
                        })
                     }
                  ]
               },
               {
                  name: 'xmpDM:videoFrameSize',
                  'atts': {
                     'stDim:unit': _videoFrameSize.unit,
                     'stDim:w': _videoFrameSize.width,
                     'stDim:h': _videoFrameSize.height
                  }
               }
            ]
         };

         if (_duration) {
            treeDesc.children.push({
               name: 'xmpDM:duration',
               'atts': {
                  'xmpDM:scale': _duration.scale,
                  'xmpDM:value': _duration.value
               }
            });
         }

         return _xmlUtility.createElementFromObject(treeDesc);
      };

      var toString = function () {
         var doc = _xmlUtility.createDocument();
         var nsElement = _xmlUtility.createElementNS(doc, _namespaceResolver('x'), 'x', 'xmpmeta');

         _.forEach(_ns, function(nsUrl, nsPrefix) {
            if (nsPrefix !== 'xml') {
               nsElement.setAttributeNS('http://www.w3.org/2000/xmlns/', ['xmlns', nsPrefix].join(':'), nsUrl);
            }
         });
         var rdfElement = _xmlUtility.createElementNS(doc, _namespaceResolver('rdf'), 'rdf', 'RDF');
         rdfElement.appendChild(toXmp());
         nsElement.appendChild(rdfElement);
         doc.appendChild(nsElement);
         return _xmlUtility.xmlDocToString(doc);
      };

      var _public = Object.defineProperties({},
         {
            version: {
               get: function () {
                  return _version;
               }
            },
            title: {
               get: function () {
                  return _title;
               }
            },
            date: {
               get: function () {
                  return _date;
               }
            },
            creator: {
               get: function () {
                  return _creator;
               }
            },
            presenterEmail: {
               get: function () {
                  return _presenterEmail;
               }
            },
            description: {
               get: function () {
                  return _description;
               }
            },
            source: {
               get: function () {
                  return _source;
               }
            },
            about: {
               get: function () {
                  return _about;
               }
            },
            keywords: {
               get: function () {
                  return _keywords;
               }
            },
            thumbnail: {
               get: function () {
                  return _thumbnail;
               }
            },
            firstFrame: {
               get: function () {
                  return _firstFrame;
               }
            },
            project: {
               get: function () {
                  return _project;
               }
            },
            originId: {
               get: function () {
                  return _originId;
               }
            },
            iPodExplicit: {
               get: function () {
                  return _iPodExplicit;
               }
            },
            documentId: {
               get: function () {
                  return _documentId;
               }
            },
            duration: {
               get: function () {
                  return _duration;
               }
            },
            videoFrameSize: {
               get: function () {
                  return _videoFrameSize;
               }
            },
            tocThumbnailImageSrc: {
               get: function() {
                  if(_containsToc && _tableOfContentsTrack.items[0].image !== undefined) {
                     return _tableOfContentsTrack.items[0].image;
                  } else if(_containsSpeechText && _speechTrack.markers[0].image !== undefined) {
                     return _speechTrack.markers[0].image;
                  } else if(_containsScreenText && _screenTextTrack.markers[0].image !== undefined) {
                     return _screenTextTrack.markers[0].image;
                  } else if(_containsCaptions && _captionTrack.captionCollection.captions[0].image !== undefined) {
                     return _captionTrack.captionCollection.captions[0].image;
                  } else {
                     return '';
                  }
               }
            },
            containsTocThumbnails: {
               get: function() {
                  return _containsTocThumbnails;
               }
            },
            containsToc: {
               get: function() {
                  return _containsToc;
               }
            },
            containsCaptions: {
               get: function() {
                  return _containsCaptions;
               }
            },
            containsHotspots: {
               get: function() {
                  return _containsHotspots;
               }
            },
            containsQuiz: {
               get: function() {
                  return _containsQuiz;
               }
            },
            containsQuizQuestions: {
               get: function() {
                  return _containsQuizQuestions;
               }
            },
            containsScreenText: {
               get: function() {
                  return _containsScreenText;
               }
            },
            containsSpeechText: {
               get: function() {
                  return _containsSpeechText;
               }
            },
            captionTrack: {
               get: function () {
                  return _captionTrack;
               },
               set: function (value) {
                  _captionTrack = value;
               }
            },
            hotspotTrack: {
               get: function () {
                  return _hotspotTrack;
               },
               set: function (value) {
                  _hotspotTrack = value;
               }
            },
            tableOfContentsTrack: {
               get: function () {
                  return _tableOfContentsTrack;
               },
               set: function (value) {
                  _tableOfContentsTrack = value;
               }
            },
            quizTrack: {
               get: function () {
                  return _quizTrack;
               },
               set: function (value) {
                  _quizTrack = value;
               }
            },
            speechTrack: {
               get: function () {
                  return _speechTrack;
               }
            },
            screenTextTrack: {
               get: function () {
                  return _screenTextTrack;
               }
            },
            controller: {
               get: function () {
                  return _controller;
               }
            },
            contentList: {
               get: function () {
                  return _contentList;
               }
            }
         });

      var parseLanguageName = function (languageNameElement) {
         return {
            langName: languageNameElement.getAttribute('xml:lang'),
            langValue: _xmlUtility.getElementText(languageNameElement)
         };
      };

      var parseLanguages = function (langNameElement) {
         if (langNameElement) {
            var languageNameElements = _xmlUtility.getElementsByTagNameNSPrefix(langNameElement, 'rdf:li');
            var languageNames = _.map(languageNameElements, parseLanguageName);
            return languageNames;
         }

         return null;
      };

      var parseProductionDetails = function (doc) {
         var rootDescriptionElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'rdf:Description');
         _version = rootDescriptionElement.getAttribute('tsc:version');
         _title = rootDescriptionElement.getAttribute('dc:title');
         _documentId = rootDescriptionElement.getAttribute('xmpMM:DocumentID');

         var videoFrameSizeElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'xmpDM:videoFrameSize');
         _videoFrameSize = {
            unit: videoFrameSizeElement ? videoFrameSizeElement.getAttribute('stDim:unit') : 'pixel',
            width: videoFrameSizeElement ? Number(videoFrameSizeElement.getAttribute('stDim:w')) : 0,
            height: videoFrameSizeElement ? Number(videoFrameSizeElement.getAttribute('stDim:h')) : 0
         };

         var langNameElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'tsc:langName');
         _languages = parseLanguages(langNameElement);

         // optional attributes below

         _presenterEmail = rootDescriptionElement.getAttribute('tscDM:presenteremail') || undefined;
         _source = rootDescriptionElement.getAttribute('dc:source') || undefined;
         _date = rootDescriptionElement.getAttribute('dc:date') || undefined;
         _about = rootDescriptionElement.getAttribute('rdf:about') || undefined;
         _creator = rootDescriptionElement.getAttribute('dc:creator') || undefined;
         _description = rootDescriptionElement.getAttribute('dc:description') || undefined;
         _keywords = rootDescriptionElement.getAttribute('tscDM:keywords') || undefined;
         _thumbnail = rootDescriptionElement.getAttribute('tscDM:thumbnail') || undefined;
         _firstFrame = rootDescriptionElement.getAttribute('tscDM:firstFrame') || undefined;
         _project = rootDescriptionElement.getAttribute('tscDM:project') || undefined;
         _originId = rootDescriptionElement.getAttribute('tscDM:originId') || undefined;
         _iPodExplicit = rootDescriptionElement.getAttribute('tscDM:iPodExplicit') || undefined;

         var durationElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'xmpDM:duration') || undefined;
         if (durationElement) {
            _duration = {
               scale: durationElement.getAttribute('xmpDM:scale'),
               value: Number(durationElement.getAttribute('xmpDM:value'))
            };
         }
      };

      var getElementForTrackType = function (elements, trackType) {
         return _.find(elements, function (element) {
            return _xmlUtility.hasAttributeWithValue(element, 'xmpDM:trackType', trackType);
         });
      };

      var parseCaptionTrack = function (tracksDescriptionElements) {
         var captionTrackElement = getElementForTrackType(tracksDescriptionElements, 'Caption');
         if (captionTrackElement) {
            return tscme.CaptionTrack.createFromXmpElement(captionTrackElement);
         }
         return null;
      };

      var parseHotspotTrack = function (tracksDescriptionElements) {
         var hotspotTrackElement = getElementForTrackType(tracksDescriptionElements, 'Hotspot');
         if (hotspotTrackElement) {
            return tscme.HotspotTrack.createFromXmpElement(hotspotTrackElement);
         }
         return null;
      };

      var parseTableOfContentsTrack = function (tracksDescriptionElements) {
         var tableOfContentsTrackElement = getElementForTrackType(tracksDescriptionElements, 'TableOfContents');
         if (tableOfContentsTrackElement) {
            return tscme.TableOfContentsTrack.createFromXmpElement(tableOfContentsTrackElement);
         }
         return null;
      };

      var parseQuizTrack = function (tracksDescriptionElements) {
         var quizTrackElement = getElementForTrackType(tracksDescriptionElements, 'Quiz');
         if (quizTrackElement) {
            return tscme.QuizTrack.createFromXmpElement(quizTrackElement);
         }
         return null;
      };

      var parseSpeechTrack = function (tracksDescriptionElements) {
         var speechTrackElement = getElementForTrackType(tracksDescriptionElements, 'Speech');
         if (speechTrackElement) {
            return tscme.SpeechTrack.createFromXmpElement(speechTrackElement);
         }
         return null;
      };

      var parseScreenTextTrack = function (tracksDescriptionElements) {
         var screenTextTrackElement = getElementForTrackType(tracksDescriptionElements, 'ScreenText');
         if (screenTextTrackElement) {
            return tscme.ScreenTextTrack.createFromXmpElement(screenTextTrackElement);
         }
         return null;
      };

      var parseTracks = function (doc) {
         var tracksElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'xmpDM:Tracks');
         var tracksDescriptionElements = _xmlUtility.getElementsByTagNameNSPrefix(tracksElement, 'rdf:Description');

         _captionTrack = parseCaptionTrack(tracksDescriptionElements);
         _hotspotTrack = parseHotspotTrack(tracksDescriptionElements);
         _tableOfContentsTrack = parseTableOfContentsTrack(tracksDescriptionElements);
         _quizTrack = parseQuizTrack(tracksDescriptionElements);
         _speechTrack = parseSpeechTrack(tracksDescriptionElements);
         _screenTextTrack = parseScreenTextTrack(tracksDescriptionElements);

         var controllerElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc, 'tscDM:controller');
         _controller = tscme.Controller.createFromXmpElement(controllerElement);

         var contentListElement = _xmlUtility.getFirstElementByTagNameNSPrefix(doc,'tscDM:contentList');
         _contentList = tscme.ContentList.createFromXmpElement(contentListElement);

         recordXmpContentFlags();
      };

      var recordXmpContentFlags = function() {
         _containsToc = (_tableOfContentsTrack !== null && _tableOfContentsTrack.items.length > 0);
         _containsCaptions = (_captionTrack !== null && _captionTrack.captionCollection.captions.length > 0);
         _containsHotspots = (_hotspotTrack !== null && _hotspotTrack.hotspots.length > 0);
         _containsQuiz = _quizTrack !== null;
         _containsQuizQuestions = (_quizTrack !== null && _quizTrack.questionSets.length > 0);
         _containsScreenText = (_screenTextTrack !== null && _screenTextTrack.markers.length > 0);
         _containsSpeechText = (_speechTrack !== null && _speechTrack.markers.length > 0);

         _containsTocThumbnails = (_containsToc && _tableOfContentsTrack.items[0].image !== undefined) ||
                                  (_containsSpeechText && _speechTrack.markers[0].image !== undefined) ||
                                  (_containsScreenText && _screenTextTrack.markers[0].image !== undefined) ||
                                  (_containsCaptions && _captionTrack.captionCollection.captions[0].image !== undefined);
      };

      var parse = function () {
         // current 'parse' does NOT deal with different versions of the TSC-XMP schema, as far as we have tested
         // all existing versions of the schema from 2.0.0 - 2.1.0 will parse using this mechanism, but neither parser
         // nor output formatter attempt to take a 2.0.0 and formally migrate it forward to 2.1.0.  Nor is the 'version'
         // property of the xml doc ever modified during reading a writing of a particular source.  this note is here
         // because will have to deal with versioning someday.  (JMD: 2016-05)
         var doc = _xmlUtility.parseXml(xmpXml);
         parseProductionDetails(doc);
         parseTracks(doc);
      };

      parse();

      _public.toXmp = toXmp;
      _public.toString = toString;

      _public.toPOJO = function() {
         var pojo = {version: _version,
            title: _title,
            documentId: _documentId,
            languages: _languages,
            videoFrameSize: _videoFrameSize,
            source: _source,
            presenterEmail: _presenterEmail,
            date: _date,
            about: _about,
            creator: _creator,
            description: _description,
            keywords: _keywords,
            thumbnail: _thumbnail,
            firstFrame: _firstFrame,
            project: _project,
            originId: _originId,
            iPodExplicit: _iPodExplicit,
            duration: _duration,
            captionTrack: _captionTrack ? _captionTrack.toPOJO() : undefined,
            hotspotTrack: _hotspotTrack ? _hotspotTrack.toPOJO() : undefined,
            quizTrack: _quizTrack ? _quizTrack.toPOJO() : undefined,
            speechTrack: _speechTrack ? _captionTrack.toPOJO() : undefined,
            screenTextTrack: _screenTextTrack ? _captionTrack.toPOJO() : undefined,
            controller: _controller ? _controller.toPOJO() : undefined,
            contentList: _contentList ? _contentList.toPOJO() : undefined
         };
         var that = this;
         var additionalProperties = _.reject(_.keys(that), function (key) {
            return _.isFunction(that[key]);
         });
         _.forEach(additionalProperties, function (key) {
            pojo[key] = that[key];
         });
         return pojo;
      };

      return _public;
   };

   tscme.Xmp = {
      /**
       *  Factory method that returns a new Xmp object.
       *  @function create
       *  @param {String} xmpXml - XMP XML string to parse.
       *  @static
       *  @return {tscme.Xmp} new Xmp instance
       */
      create: function (xmpXml) {
         return new Xmp(xmpXml);
      },
      /**
       *  Namespace resolver for xmp namespaces.
       *  @function create
       *  @param {String} prefix - XML namespace prefix
       *  @static
       *  @return {String} The namespace corresponding to the prefix or null if not found
       */
      namespaceResolver: _namespaceResolver
   };
})(tscme, _);

return tscme;

}));
